(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6514],{

/***/ 88429:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jewellery/[slug]",
      function () {
        return __webpack_require__(47693);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/MetalWeight-platinum.aca2968a.svg","height":28,"width":32});

/***/ }),

/***/ 65664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/MetalWeight-silver.e9db8894.svg","height":28,"width":32});

/***/ }),

/***/ 73038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/MetalWeight-titanium.5dd3a8b5.svg","height":28,"width":32});

/***/ }),

/***/ 57042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/MetalWeight.5339f77b.svg","height":28,"width":32});

/***/ }),

/***/ 52266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/SGL-CRT.749a7c37.jpg","height":1747,"width":2479,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAdEAACAgEFAAAAAAAAAAAAAAABAgADEwQhMUHw/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABURAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIRAxEAPwClJqacjLhAWtzsByPdRERCv//Z"});

/***/ }),

/***/ 2737:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/adv-header.58f7bcba.png","height":139,"width":1600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAADFBMVEX39PD7ztL53+D///+EgHUnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVR4nGNgZmBkZGJgYAYAADcAC8ZUW+gAAAAASUVORK5CYII="});

/***/ }),

/***/ 62511:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon-adv.015d447b.jpg","height":307,"width":343,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAeEAABBAMAAwAAAAAAAAAAAAACAAEDEQQFISIxkf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAECEhP/2gAMAwEAAhEDEQA/AKZPrNnJnm4bCWPHM2NnE+j68aqq5X1ERGqKaSP/2Q=="});

/***/ }),

/***/ 99749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/made-in-india.5c8b4029.png","height":23,"width":35,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAWlBMVEXJdQT4xmT4oQi8awP//f/lmh4UhSwAaSQAeynmkguRm8O/0/fi2uT///9xs3AAaCfo4OcUiCsFeypkqXNHjGVto4MGfyfntG69i0rFkT+3fjV+uofboEHR0+JUzQSzAAAAE3RSTlPT/NTG/M277eBm+/v5x6a63c28MGYoNQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADNJREFUeJxjYGJgZgViTgZGGSlJRnEJVgZeFh4ubhZZAQY+aVERYWERYQY2MXYOQSF+NgAm3wIDabtAuwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 76873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/metal-platinum.470fb726.svg","height":27,"width":32});

/***/ }),

/***/ 91332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/metal-silver.e92ecd7f.svg","height":27,"width":32});

/***/ }),

/***/ 77090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/metal-titanium.da4783d3.svg","height":27,"width":32});

/***/ }),

/***/ 95409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/metal.765917ab.svg","height":27,"width":32});

/***/ }),

/***/ 25439:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/prodd1.7cf49edb.png","height":56,"width":56,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEX/GTL/GDH/GDH/GDL/GTL/GDL/GDH/GDH/GDH/GTIsbA0uAAAACnRSTlMBC1kZSDUkgJJw8cXZwQAAAAlwSFlzAAAPYAAAD2ABenhFjQAAADVJREFUeJwVyrkRADAIA0F9gN1/w8YXaDYQAMs2tjrRrEpFicBcgrWgwz5aVMZpMOj/QP5sDxhJAKCHY9C8AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 77492:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/prodd2.24cfddc5.png","height":44,"width":44,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX/GDJHcEz/GTL/GTL/GDL/GDH/GDH/GTL/GTL/GTL/GTL/GDFcUam9AAAADHRSTlNBACYPTDQeUnmGZ6cBPbXTAAAACXBIWXMAAA9gAAAPYAF6eEWNAAAAN0lEQVR4nBXKtwHAMBADsSM/Key/r+UKDVAPZIge2bGDkQ7lBNe6u4DnKeV7LBSJd7Q1jf43rQ8jbAD6FLSQvgAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 56668:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/prodd3.d1759175.png","height":51,"width":51,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEX/GDL/GDJHcEz/GDL/GTL/GDGBylFDAAAABnRSTlM7SwAkXROb1xVcAAAACXBIWXMAAA9gAAAPYAF6eEWNAAAAMElEQVR4nDXLQQ4AMAgCwQX0/18uTVPDaUAcgWIi9xhY7S5lq9rKL1wbqdwVGcJ/PxBFAG3GhPMsAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 55824:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/prodd4.f9ceddb4.png","height":52,"width":52,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAD1BMVEX/GTL/GDH/GTL/GDFHcEyVhb3RAAAABXRSTlNGKz4fAIFERWMAAAAJcEhZcwAAD2AAAA9gAXp4RY0AAAAuSURBVHicHcvBAQAwEAFBrP5rjovnQMWSqYiWIGQPx6ldH4+0nlGziiw3Lvz7Aw3mAGggvEqqAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 11087:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/prodd5.47030864.png","height":48,"width":38,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAD1BMVEX/GTL/GDL/GDL/GDH/GTJ61yUxAAAABXRSTlNGATIgFAXVDRwAAAAJcEhZcwAAD2AAAA9gAXp4RY0AAAAoSURBVHicJYmJCQAwEMLis//M9WgQlAgfa5hITVammfQC3QeaptysHgdXAEa8GOc8AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 37018:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/prodd6.d95cdea8.png","height":52,"width":38,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAFVBMVEX/GTL/GTL/GTL/GTJHcEz/GTL/GDGbNEd3AAAAB3RSTlM7KxhgAE4EkEpj1wAAAAlwSFlzAAAPYAAAD2ABenhFjQAAAClJREFUeJwliMcRADAMwmjO/iMbX3gIEB6aAGy6KJ34j+0DZgqfMWLJWQYHAEJM+WcuAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 27820:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/prodd7.1298e24e.png","height":46,"width":43,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAADFBMVEVHcEz/GTL/GTL/GDGguoyfAAAABHRSTlMAOkgIrBRL4wAAAAlwSFlzAAAPYAAAD2ABenhFjQAAACdJREFUeJxVibENAAAIwir+/7M1Tg6kBaCSFGx0Fordw06T5sbPeDIGqgAwhV+VNwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 55603:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/prodd8.82456478.png","height":45,"width":50,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAElBMVEX/GTL/GDH/GDH/GDL/GDH/GTKPI0YkAAAABnRSTlM6Ay1DEGJFHQ/VAAAACXBIWXMAAA9gAAAPYAF6eEWNAAAALElEQVR4nCXJwQ0AMAyDQGyS/Vduq94LCbrCEpyHYQvUgVzlR62YiXkfW/QADv4Ab2X3wMkAAAAASUVORK5CYII="});

/***/ }),

/***/ 50205:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s11.1ce8e384.png","height":269,"width":317,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAIVBMVEX////8+/rq39jl1M7y4+H48e/y6+bQtp7mf4TFhofO1M/ZMBTaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMklEQVR4nB2KQQ4AIAzCGBub+v8Hi/ZAaFIAYWCozKD9RBFHqJ1ND3pVU4uvmvkxQvK5EwwAoh6KyboAAAAASUVORK5CYII="});

/***/ }),

/***/ 56742:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s12.5c4b9938.png","height":389,"width":373,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX////8+/q5kmrSycG6mnbp6Obl4t/NT0rd1c3GtKTGs6L7+PV9SXnSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVR4nFXKQQ4AIAgDQShUUP//X3syYU/TpGY/LkUhUh0XUIWJBLCFDrJDZ9fwaw8abADGejF5rwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 45624:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s13.2ab4d420.png","height":373,"width":285,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAJFBMVEX+//7iKjjw7un39fPbrqnn4Nrd0snSwrfrzcvLW1naTFPMRUZ0WdnIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALUlEQVR4nCWKRwIAIAyDknQ5/v9ftXIEgI+lIgxRWQlok/NaJ8eLXP249ysBBw77AHsfOPDLAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 10631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s14.b6cba245.png","height":413,"width":441,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAG1BMVEX////6+ff08e7s5+TFrqLl39vGvrjd1tDmyL+lTdhyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nB2JSRIAMAjCWNT2/y+ulEsyBABkZCRFrthrnaA+UtqtOqFnavgP9/IBC3AAdiIVhckAAAAASUVORK5CYII="});

/***/ }),

/***/ 66202:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s2.03af46af.png","height":329,"width":305,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAOVBMVEX////8+/rv6ujdxLb08e/sMT+wubbo4d+5k2vJysby7urHw7zJkpLEgYK+pIrv5t7o2s7LeX/02tk+sYoAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nB2HxxEAIAzD7IQWOuw/LEf0kQSAQnx0qscq27+WZgJC40gZwXo83637M8hdlQ8dawE1P6cWOAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 30516:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s3.65039ea4.png","height":345,"width":333,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEX////k2M+/l43Nysnr4d78+/r28/DHv7nCsqLIuKm8rZ+N7ICKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3JyQ3AMAwDwZWoy+6/4MiZzxIgECshw5cl1TqjLrCe28YKaZ9H+pPHfeoNW8UHHk8AxQU33/gAAAAASUVORK5CYII="});

/***/ }),

/***/ 81806:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s4.caa05980.png","height":329,"width":245,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAANlBMVEX////z7+7HwL7m4N339vT7+PfMysn05+XAUk7My8vtk5jja3LgXWXgNkHX09Dv2tjCYmDARUI1zorPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nA3JNwIAIAjAwAAq9vL/z0qWDAekRGStGEi5VQVp9cXYqjtszDHDVu/LyeZy8gcYPgEOc/YoqAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 71380:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s5.8a3afbb9.png","height":289,"width":373,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAHlBMVEX+/v7e1dH28u/69/bby7u1iVzWv6fp5eHIwLeyn5ChRv2/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVR4nB2KQRIAIAiEWFez/v/hMk4MA4CDISQxam31b6uOnjhXVapnzTRcCSYAbTegMCIAAAAASUVORK5CYII="});

/***/ }),

/***/ 77787:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s6.f883ab39.png","height":305,"width":268,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAHlBMVEX+/f3s6uTo49zk2tP38/Hmi4/js7DyByDkfIHjdHqcX3PVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVR4nBWKhwkAMBACbWn7LxwfRcETAJQGqKrtvbaDcJ3HDvI1B5dLiD1GD2LwAQ+4AIaqSYICAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 10906:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s7.7426d27c.png","height":433,"width":397,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAJFBMVEX////u6uX29PLp5N77+vnErpq9kIXk29TNeHTSn5nitbG+VFBfO5TuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVR4nBWKCwrAUAzCYm3fZ7v/fecQEwQBXAHVCfQOpL9SFc+6VOZ5j8f5ybMmbm83Hw+gAJami1LzAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 32223:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s8.ad2f13ec.png","height":369,"width":393,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAALVBMVEX////Jwry6mom5pZvh3tv7+/rSyMP29PPf18/GuLLw7Om/hoCkiXDs6+m5c29Tt9XkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANklEQVR4nD2JxxEAMAzCwC1O3X/clEf0QZyASzF/i1jz3WAtcO2qpMNFyMhTjFVHHGlGkcRnAx6gAMvKghD2AAAAAElFTkSuQmCC"});

/***/ }),

/***/ 98047:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/s9.21a87a68.png","height":453,"width":301,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAIVBMVEX////q2dP26ej38O7px8T8+fjXoJfSlImxUTbhfIDw09Lv5eRBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nB3KuQEAIAzDQOUhAfYfGIfm5MKALSByKHdX7VzIntnbZH1DzwcI7wBm5iawsgAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 75908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14434);
/* harmony import */ var _styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88494);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);
/* harmony import */ var _product_card_product_card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91740);
/* harmony import */ var _lib_unbxd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22236);
/* eslint-disable react-hooks/exhaustive-deps */ 








swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_
]);
var Trending_Design = function(param) {
    var product = param.product, pagetype = param.pagetype;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(product === null || product === void 0 ? void 0 : (ref = product.headers) === null || ref === void 0 ? void 0 : ref["unbxd-request-id"]), requestId = ref3[0], setrequestId = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        trendingDesign();
    }, []);
    var trendingDesign = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, products, payload;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        products = ((ref = product.data.widget2) === null || ref === void 0 ? void 0 : ref.recommendations.filter(function(v) {
                            return !!v.variantId;
                        }).map(function(product) {
                            var ref, ref1, ref2, ref3;
                            return {
                                id: product === null || product === void 0 ? void 0 : product.productId,
                                title: product === null || product === void 0 ? void 0 : product.title,
                                slug: product === null || product === void 0 ? void 0 : product.productUrl.split("/")[(product === null || product === void 0 ? void 0 : product.productUrl.split("/").length) - 1],
                                sku: product === null || product === void 0 ? void 0 : product.uniqueId,
                                try_online: (product === null || product === void 0 ? void 0 : (ref = product.hasTryOnline) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "true",
                                image: product === null || product === void 0 ? void 0 : product.imageUrl[0],
                                priceId: product.variantId,
                                price: product === null || product === void 0 ? void 0 : product.price,
                                discount: {
                                    total: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    name: (product === null || product === void 0 ? void 0 : product.discountLabel) || null,
                                    price: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    text: (product === null || product === void 0 ? void 0 : product.discountLabel) || null
                                },
                                fastDelivery: (product === null || product === void 0 ? void 0 : (ref1 = product.vIsFastDelivery) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "true",
                                // deal_of_the_day: null,
                                categories: [
                                    {
                                        name: product.categoryPath1[0]
                                    }
                                ],
                                // trending: null,
                                // featured: null,
                                // recomemded: null,
                                best_seller: (product === null || product === void 0 ? void 0 : (ref2 = product.isBestSeller) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "true",
                                new_arrival: (product === null || product === void 0 ? void 0 : (ref3 = product.isNewArrival) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "true"
                            };
                        })) || [];
                        setData(products);
                        setTitle(product.data.widget2.widgetTitle);
                        if (products.length) {
                            payload = {
                                requestId: requestId,
                                pids_list: products.map(function(v) {
                                    return v.sku;
                                }),
                                experience_pagetype: pagetype,
                                experience_widget: "WIDGET2"
                            };
                            (0,_lib_unbxd__WEBPACK_IMPORTED_MODULE_7__/* .unbxdTrackEvent */ .Eg)("experience_impression", payload);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function trendingDesign() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
            className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().trending_design),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "container-fluid",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().trending_design_header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_styles_trending_design_module_scss__WEBPACK_IMPORTED_MODULE_8___default().h2),
                                    children: [
                                        title,
                                        " "
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "col-md-12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                                        className: "swiper swiper-custom-arrows",
                                        navigation: true,
                                        spaceBetween: 20,
                                        slidesPerView: 2,
                                        breakpoints: {
                                            640: {
                                                slidesPerView: 2
                                            },
                                            768: {
                                                slidesPerView: 3
                                            },
                                            1024: {
                                                slidesPerView: 4
                                            },
                                            1200: {
                                                slidesPerView: 5
                                            }
                                        },
                                        children: data.map(function(product) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_product_card_product_card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    product: product,
                                                    unbxd: {
                                                        isunbxd: true,
                                                        requestId: requestId,
                                                        experience_pagetype: pagetype,
                                                        experience_widget: "WIDGET2"
                                                    }
                                                })
                                            }, product.id);
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Trending_Design);


/***/ }),

/***/ 47693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/lib/ga4.ts
var ga4 = __webpack_require__(77981);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/home/trending_design.tsx
var trending_design = __webpack_require__(75908);
// EXTERNAL MODULE: ./src/components/product-details/breadcrumb/breadcrumb.tsx
var breadcrumb = __webpack_require__(12936);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/assets/images/prodd1.png
var prodd1 = __webpack_require__(25439);
// EXTERNAL MODULE: ./src/assets/images/prodd2.png
var prodd2 = __webpack_require__(77492);
// EXTERNAL MODULE: ./src/assets/images/prodd3.png
var prodd3 = __webpack_require__(56668);
// EXTERNAL MODULE: ./src/assets/images/prodd4.png
var prodd4 = __webpack_require__(55824);
// EXTERNAL MODULE: ./src/assets/images/prodd5.png
var prodd5 = __webpack_require__(11087);
// EXTERNAL MODULE: ./src/assets/images/prodd6.png
var prodd6 = __webpack_require__(37018);
// EXTERNAL MODULE: ./src/assets/images/prodd7.png
var prodd7 = __webpack_require__(27820);
// EXTERNAL MODULE: ./src/assets/images/prodd8.png
var prodd8 = __webpack_require__(55603);
// EXTERNAL MODULE: ./src/components/product-details/certificate/certificate.module.scss
var certificate_module = __webpack_require__(74670);
var certificate_module_default = /*#__PURE__*/__webpack_require__.n(certificate_module);
;// CONCATENATED MODULE: ./src/components/product-details/certificate/certificate.tsx












var ProductDetailsCertificate = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (certificate_module_default()).certificate_container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (certificate_module_default()).heading,
                    children: "With Every Product You Buy You Get"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3 col-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (certificate_module_default()).icon_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd1/* default */.Z,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Senco Five-Star Promise"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3 col-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (certificate_module_default()).icon_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd2/* default */.Z,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Zero Deduction Gold Exchange"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3 col-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (certificate_module_default()).icon_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd3/* default */.Z,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Easy Exchange"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3 col-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (certificate_module_default()).icon_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd4/* default */.Z,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Assured Lifetime Maintenance"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3 col-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (certificate_module_default()).icon_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd5/* default */.Z,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Tested & Certified Diamonds"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3 col-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (certificate_module_default()).icon_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd6/* default */.Z,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "BIS Hallmarked Pure Gold"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3 col-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (certificate_module_default()).icon_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd7/* default */.Z,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Guaranteed Buyback"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-md-3 col-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (certificate_module_default()).icon_card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: prodd8/* default */.Z,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "7 Days Return Policy"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var certificate = (ProductDetailsCertificate);

// EXTERNAL MODULE: ./src/components/product-details/delivery/delivery.module.scss
var delivery_module = __webpack_require__(65065);
var delivery_module_default = /*#__PURE__*/__webpack_require__.n(delivery_module);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/slices/product.ts
var slices_product = __webpack_require__(64975);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/assets/images/fast.svg
var fast = __webpack_require__(37726);
;// CONCATENATED MODULE: ./src/components/product-details/delivery/delivery.tsx












var ProductDetailsDelivery = function() {
    var ref, ref1, ref2, ref3, ref4;
    var dispatch = (0,es/* useDispatch */.I0)();
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var ref5 = (0,react.useState)(""), pincode = ref5[0], setPincode = ref5[1];
    var ref6 = (0,react.useState)(true), isInitialLoad = ref6[0], setIsInitialLoad = ref6[1];
    var intervalRef = (0,react.useRef)(null);
    var isUserTyping = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        var savedPincode = (0,lib.getCookie)("userPincode");
        if (savedPincode) {
            var ref;
            var pincodeValue = savedPincode === null || savedPincode === void 0 ? void 0 : savedPincode.toString();
            setPincode(pincodeValue);
            if (((ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug) && pincodeValue.length === 6) {
                checkPincodeWithValue(pincodeValue);
            }
        }
        setIsInitialLoad(false);
        var checkCookieChanges = function() {
            if (!isUserTyping.current) {
                var currentPincode = (0,lib.getCookie)("userPincode");
                var currentValue = currentPincode ? currentPincode === null || currentPincode === void 0 ? void 0 : currentPincode.toString() : "";
                setPincode(function(prevPincode) {
                    if (prevPincode !== currentValue) {
                        var ref;
                        if (currentValue.length === 6 && ((ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug)) {
                            checkPincodeWithValue(currentValue);
                        }
                        return currentValue;
                    }
                    return prevPincode;
                });
            }
        };
        intervalRef.current = setInterval(checkCookieChanges, 1000);
        return function() {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [
        (ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug
    ]);
    var scrollToFindStore = function() {
        var element = document.getElementById("find-store-section");
        element === null || element === void 0 ? void 0 : element.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };
    var ref7 = (0,react.useState)(false), enabled = ref7[0], setEnabled = ref7[1];
    var isFast = (0,react.useMemo)(function() {
        var ref;
        return (ref = productState.data) === null || ref === void 0 ? void 0 : ref.prices.find(function(v) {
            return v.shipping_days <= parseInt("3" || 0) && v.stock > 0;
        });
    }, [
        productState
    ]);
    var checkPincodeWithValue = function(pincodeValue) {
        var isUserAction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        if ((ref = productState.data) === null || ref === void 0 ? void 0 : ref.sku) {
            dispatch((0,slices_product/* fetchLocation */.Kx)({
                slug: productState.data.sku,
                pincode: pincodeValue,
                size: ""
            }));
        }
        // Only show toast messages and do full pincode check if this was a user action
        if (isUserAction) {
            if (pincodeValue.length === 6) {
                (0,lib.setCookie)("userPincode", pincodeValue, {
                    maxAge: 30 * 24 * 60 * 60,
                    sameSite: "strict"
                });
                http_client/* default.get */.Z.get(endpoints/* default.checkPincode */.Z.checkPincode(pincodeValue)).then(function(res) {
                    if (res.data.status) {
                        (0,react_toastify_esm/* toast */.Am)(res.data.message, {
                            type: "success",
                            toastId: "check-pincode-success"
                        });
                    } else {
                        (0,react_toastify_esm/* toast */.Am)(res.data.message, {
                            type: "error",
                            toastId: "check-pincode-error"
                        });
                    }
                }).catch(function() {
                    (0,react_toastify_esm/* toast */.Am)("Something went wrong. Try again", {
                        type: "error",
                        toastId: "check-pincode-error"
                    });
                });
            } else {
                (0,react_toastify_esm/* toast */.Am)("Pincode must be 6 digit", {
                    type: "error",
                    toastId: "check-pincode-length-error"
                });
            }
        }
    };
    var checkPincode = function() {
        checkPincodeWithValue(pincode, true);
    };
    var handlePincodeChange = function(e) {
        var newPincode = e.target.value;
        isUserTyping.current = true;
        setPincode(newPincode);
        if (newPincode.length === 6) {
            (0,lib.setCookie)("userPincode", newPincode, {
                maxAge: 30 * 24 * 60 * 60,
                sameSite: "strict"
            });
        }
        // Clear the typing flag after a short delay
        setTimeout(function() {
            isUserTyping.current = false;
        }, 5000);
    };
    var handleInputFocus = function() {
        isUserTyping.current = true;
    };
    var handleInputBlur = function() {
        setTimeout(function() {
            isUserTyping.current = false;
        }, 500);
    };
    if (!productState.selectedPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var ref8;
    var stock = (ref8 = (ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.stock) !== null && ref8 !== void 0 ? ref8 : 0;
    var ref9;
    var blockStock = (ref9 = (ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.block_stock) !== null && ref9 !== void 0 ? ref9 : 0;
    var leftInStock = stock - blockStock;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (delivery_module_default()).fast_delivery,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    isFast && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (delivery_module_default()).delivery_icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: fast/* default */.Z,
                                        alt: "Fast Delivery",
                                        width: 24,
                                        height: 24,
                                        unoptimized: true,
                                        priority: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ms-1",
                                        children: "Fast Delivery"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-11 col-lg-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (delivery_module_default()).check_delevery,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (delivery_module_default()).product_link1,
                                    children: "Check Delivery Options"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (delivery_module_default()).delivery_filed,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "bi bi-geo-alt"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "number",
                                            maxLength: 6,
                                            placeholder: "Enter your pincode",
                                            value: pincode,
                                            onChange: handlePincodeChange,
                                            onFocus: handleInputFocus,
                                            onBlur: handleInputBlur
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            "aria-label": "check Pincode",
                                            role: "button",
                                            onClick: checkPincode,
                                            children: "Check"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !!((ref3 = productState.selectedPrice) === null || ref3 === void 0 ? void 0 : ref3.shipping_days) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (delivery_module_default()).truck,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "20",
                                    height: "17",
                                    viewBox: "0 0 20 17",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M18.7031 3.69647H19.4031V3.69647H18.7031ZM15.6393 8.0202L15.2573 8.60675C15.4895 8.75801 15.7891 8.75801 16.0213 8.60675L15.6393 8.0202ZM12.5755 3.69647H11.8755V3.69647H12.5755ZM15.6393 0.703125V1.40312V0.703125ZM6.83078 5.42752C7.21738 5.42752 7.53078 5.11411 7.53078 4.72752C7.53078 4.34092 7.21738 4.02752 6.83078 4.02752V4.72752V5.42752ZM5.68185 12.808C5.29525 12.808 4.98185 13.1214 4.98185 13.508C4.98185 13.8946 5.29525 14.208 5.68185 14.208V13.508V12.808ZM3.90541 4.74773L4.06189 5.43002V5.43002L3.90541 4.74773ZM3.68401 4.83534L4.03765 5.43944V5.43944L3.68401 4.83534ZM0.76143 13.0563L0.119204 13.3348L0.119204 13.3348L0.76143 13.0563ZM1.85206 14.208C2.23866 14.208 2.55206 13.8946 2.55206 13.508C2.55206 13.1214 2.23866 12.808 1.85206 12.808V13.508V14.208ZM1.17596 13.4523L0.91841 14.1032H0.91841L1.17596 13.4523ZM0.724288 9.25003L0.0454 9.07941L0.0453991 9.07941L0.724288 9.25003ZM0.815996 9.03853L0.226804 8.66057L0.226804 8.66057L0.815996 9.03853ZM10.6606 3.23239C11.0472 3.23239 11.3606 2.91899 11.3606 2.53239C11.3606 2.14579 11.0472 1.83239 10.6606 1.83239V2.53239V3.23239ZM18.2542 8.86118C18.2542 8.47458 17.9408 8.16118 17.5542 8.16118C17.1676 8.16118 16.8542 8.47458 16.8542 8.86118H17.5542H18.2542ZM7.66722 2.6919L7.97358 3.3213L7.97358 3.3213L7.66722 2.6919ZM6.99775 3.33143L7.61539 3.66086V3.66086L6.99775 3.33143ZM3.33213 5.18885L2.74284 4.81104V4.81104L3.33213 5.18885ZM3.39273 5.09825L2.83389 4.67671V4.67671L3.39273 5.09825ZM3.51151 4.97231L3.98806 5.48505L3.51151 4.97231ZM3.44046 5.04121L3.95407 5.51682L3.44046 5.04121ZM18.7031 3.69647H18.0031C18.0031 4.57303 17.4082 5.48149 16.6687 6.2441C16.3143 6.60958 15.9574 6.9101 15.6882 7.11952C15.5542 7.22379 15.4433 7.30435 15.3674 7.35795C15.3294 7.38473 15.3003 7.4047 15.2814 7.41747C15.272 7.42385 15.2651 7.42843 15.261 7.43114C15.259 7.4325 15.2576 7.43339 15.257 7.43381C15.2567 7.43402 15.2565 7.43411 15.2566 7.43408C15.2566 7.43407 15.2567 7.43403 15.2568 7.43395C15.2568 7.43392 15.257 7.43384 15.257 7.43382C15.2571 7.43374 15.2573 7.43364 15.6393 8.0202C16.0213 8.60675 16.0215 8.60664 16.0217 8.60653C16.0218 8.60648 16.0219 8.60636 16.0221 8.60626C16.0224 8.60607 16.0227 8.60584 16.0231 8.60558C16.0239 8.60507 16.0249 8.60444 16.026 8.60368C16.0283 8.60216 16.0314 8.60016 16.0351 8.59767C16.0426 8.59269 16.053 8.58577 16.066 8.57697C16.092 8.55936 16.1287 8.53419 16.1745 8.50186C16.2661 8.43723 16.3946 8.3437 16.5478 8.22451C16.8531 7.98701 17.2622 7.64312 17.6737 7.21869C18.4662 6.40147 19.4031 5.14808 19.4031 3.69647H18.7031ZM15.6393 8.0202C16.0213 7.43364 16.0215 7.43374 16.0216 7.43382C16.0216 7.43384 16.0218 7.43392 16.0218 7.43395C16.0219 7.43403 16.022 7.43407 16.022 7.43408C16.022 7.43411 16.0219 7.43402 16.0216 7.43381C16.021 7.43339 16.0196 7.4325 16.0176 7.43114C16.0135 7.42843 16.0066 7.42385 15.9972 7.41747C15.9783 7.4047 15.9492 7.38473 15.9112 7.35795C15.8352 7.30435 15.7244 7.22379 15.5904 7.11952C15.3212 6.9101 14.9643 6.60958 14.6099 6.2441C13.8704 5.48149 13.2755 4.57303 13.2755 3.69647H12.5755H11.8755C11.8755 5.14808 12.8124 6.40147 13.6048 7.21869C14.0164 7.64312 14.4255 7.98701 14.7307 8.22451C14.884 8.3437 15.0125 8.43723 15.1041 8.50186C15.1499 8.53419 15.1866 8.55936 15.2126 8.57697C15.2256 8.58577 15.236 8.59269 15.2435 8.59767C15.2472 8.60016 15.2503 8.60216 15.2526 8.60368C15.2537 8.60444 15.2547 8.60507 15.2555 8.60558C15.2559 8.60584 15.2562 8.60607 15.2565 8.60626C15.2567 8.60636 15.2568 8.60648 15.2569 8.60653C15.2571 8.60664 15.2573 8.60675 15.6393 8.0202ZM12.5755 3.69647H13.2755C13.2755 3.09357 13.5205 2.51196 13.962 2.08056L13.4728 1.57986L12.9837 1.07916C12.2761 1.77047 11.8755 2.71161 11.8755 3.69647H12.5755ZM13.4728 1.57986L13.962 2.08056C14.4041 1.64861 15.0072 1.40312 15.6393 1.40312V0.703125V0.00312501C14.6463 0.00312501 13.6907 0.388381 12.9837 1.07916L13.4728 1.57986ZM15.6393 0.703125V1.40312C16.2714 1.40312 16.8744 1.64861 17.3166 2.08056L17.8057 1.57986L18.2949 1.07916C17.5879 0.388381 16.6323 0.00312501 15.6393 0.00312501V0.703125ZM17.8057 1.57986L17.3166 2.08056C17.7581 2.51196 18.0031 3.09357 18.0031 3.69647H18.7031H19.4031C19.4031 2.71161 19.0025 1.77047 18.2949 1.07916L17.8057 1.57986ZM16.1952 3.58252H15.4952C15.4952 3.49791 15.5632 3.43514 15.6398 3.43514V4.13514V4.83514C16.3299 4.83514 16.8952 4.27754 16.8952 3.58252H16.1952ZM15.6398 4.13514V3.43514C15.7165 3.43514 15.7845 3.49791 15.7845 3.58252H15.0845H14.3845C14.3845 4.27754 14.9498 4.83514 15.6398 4.83514V4.13514ZM15.0845 3.58252H15.7845C15.7845 3.66714 15.7165 3.72991 15.6398 3.72991V3.02991V2.32991C14.9498 2.32991 14.3845 2.88751 14.3845 3.58252H15.0845ZM15.6398 3.02991V3.72991C15.5632 3.72991 15.4952 3.66713 15.4952 3.58252H16.1952H16.8952C16.8952 2.88751 16.3299 2.32991 15.6398 2.32991V3.02991ZM0.703125 9.60269H0.00312501V12.4104H0.703125H1.40312V9.60269H0.703125ZM6.83078 4.72752V4.02752H4.27459V4.72752V5.42752H6.83078V4.72752ZM3.33213 5.18885L2.74284 4.81104C2.57099 5.07909 2.13534 5.75751 1.72851 6.38224C1.52488 6.69493 1.32987 6.99202 1.17923 7.21688C1.10362 7.32974 1.0413 7.42123 0.995586 7.4863C0.972469 7.51921 0.956298 7.5415 0.946255 7.55483C0.924285 7.58399 0.944917 7.55286 0.985554 7.51404L1.46908 8.0202L1.95261 8.52636C2.00777 8.47367 2.05297 8.41247 2.06447 8.3972C2.0879 8.3661 2.11411 8.32957 2.14114 8.2911C2.19571 8.21343 2.26473 8.11194 2.34233 7.99609C2.49813 7.76355 2.69709 7.46039 2.90168 7.14622C3.31129 6.51721 3.7491 5.83543 3.92142 5.56666L3.33213 5.18885ZM5.68185 13.508V14.208H6.83078V13.508V12.808H5.68185V13.508ZM4.27459 4.72752V4.02752C4.11919 4.02752 3.93232 4.02339 3.74894 4.06545L3.90541 4.74773L4.06189 5.43002C4.0504 5.43265 4.05033 5.43082 4.08335 5.42938C4.12245 5.42767 4.17509 5.42752 4.27459 5.42752V4.72752ZM3.51151 4.97231L3.98806 5.48505C4.01807 5.45716 4.03343 5.44401 4.0417 5.43737C4.04787 5.43242 4.04539 5.43491 4.03765 5.43944L3.68401 4.83534L3.33037 4.23124C3.20719 4.30335 3.11253 4.38748 3.03496 4.45958L3.51151 4.97231ZM3.90541 4.74773L3.74894 4.06545C3.60215 4.09911 3.46087 4.15484 3.33037 4.23124L3.68401 4.83534L4.03765 5.43944C4.04422 5.4356 4.05237 5.4322 4.06189 5.43002L3.90541 4.74773ZM0.703125 12.4104H0.00312501C0.00312501 12.5709 0.00270981 12.7279 0.0121918 12.8607C0.0221696 13.0004 0.0455812 13.165 0.119204 13.3348L0.76143 13.0563L1.40366 12.7778C1.41897 12.8132 1.41323 12.8253 1.40863 12.7609C1.40354 12.6896 1.40312 12.5909 1.40312 12.4104H0.703125ZM1.85206 13.508V12.808C1.66446 12.808 1.55726 12.8077 1.47849 12.8025C1.40542 12.7978 1.40747 12.7911 1.43352 12.8014L1.17596 13.4523L0.91841 14.1032C1.08522 14.1692 1.24687 14.1904 1.38744 14.1996C1.5223 14.2083 1.68277 14.208 1.85206 14.208V13.508ZM0.76143 13.0563L0.119204 13.3348C0.273416 13.6904 0.564553 13.9632 0.91841 14.1032L1.17596 13.4523L1.43352 12.8014C1.41201 12.7929 1.40492 12.7808 1.40366 12.7778L0.76143 13.0563ZM0.703125 9.60269H1.40312C1.40312 9.50683 1.40331 9.45902 1.40497 9.42429C1.40631 9.39636 1.40772 9.40256 1.40318 9.42064L0.724288 9.25003L0.0453991 9.07941C-0.00177729 9.26713 0.00312501 9.45846 0.00312501 9.60269H0.703125ZM1.46908 8.0202L0.985554 7.51404C0.885761 7.60937 0.788479 7.75435 0.735325 7.8341C0.664387 7.94054 0.586023 8.0656 0.513931 8.18313C0.441213 8.30168 0.371699 8.41778 0.318176 8.50754C0.290774 8.55349 0.268992 8.59014 0.251308 8.61974C0.230994 8.65374 0.225238 8.66301 0.226804 8.66057L0.815996 9.03853L1.40519 9.41648C1.42525 9.38521 1.47453 9.30186 1.52062 9.22457C1.57329 9.13624 1.63925 9.02611 1.70732 8.91513C1.77602 8.80313 1.84376 8.69535 1.9003 8.61053C1.92872 8.56788 1.951 8.53603 1.96691 8.51461C1.98939 8.48434 1.98177 8.49851 1.95261 8.52636L1.46908 8.0202ZM0.724288 9.25003L1.40318 9.42065C1.40327 9.42027 1.40369 9.41882 1.40519 9.41648L0.815996 9.03853L0.226804 8.66057C0.144311 8.78917 0.0828326 8.93047 0.0454 9.07941L0.724288 9.25003ZM10.6606 2.53239V1.83239H9.28185V2.53239V3.23239H10.6606V2.53239ZM6.83078 4.87386H6.13078V13.508H6.83078H7.53078V4.87386H6.83078ZM17.5542 11.6787H18.2542V8.86118H17.5542H16.8542V11.6787H17.5542ZM6.83078 13.508V14.208H9.89462V13.508V12.808H6.83078V13.508ZM17.5542 11.6787H16.8542C16.8542 11.9909 16.8121 12.1791 16.7599 12.2954C16.7154 12.3947 16.6526 12.4679 16.5359 12.5348C16.2392 12.7049 15.654 12.808 14.4904 12.808V13.508V14.208C15.6246 14.208 16.5713 14.1282 17.2321 13.7495C17.594 13.542 17.8664 13.2494 18.0373 12.8685C18.2005 12.5046 18.2542 12.0982 18.2542 11.6787H17.5542ZM9.28185 2.53239V1.83239C8.86391 1.83239 8.51023 1.8319 8.22122 1.85445C7.92493 1.87758 7.63696 1.92811 7.36087 2.06249L7.66722 2.6919L7.97358 3.3213C8.02518 3.29618 8.11555 3.26696 8.33016 3.25021C8.55205 3.23289 8.84183 3.23239 9.28185 3.23239V2.53239ZM6.83078 4.87386H7.53078C7.53078 4.45198 7.53138 4.17963 7.54911 3.97234C7.56605 3.77422 7.59479 3.69949 7.61539 3.66086L6.99775 3.33143L6.38012 3.002C6.23375 3.27641 6.179 3.5631 6.1542 3.85304C6.13019 4.13381 6.13078 4.47615 6.13078 4.87386H6.83078ZM7.66722 2.6919L7.36087 2.06249C6.94369 2.26556 6.5985 2.59256 6.38012 3.002L6.99775 3.33143L7.61539 3.66086C7.69075 3.51958 7.81427 3.39884 7.97358 3.3213L7.66722 2.6919ZM9.89462 13.508H9.19461C9.19461 15.1368 10.5673 16.4031 12.1925 16.4031V15.7031V15.0031C11.2795 15.0031 10.5946 14.3039 10.5946 13.508H9.89462ZM12.1925 15.7031V16.4031C13.8176 16.4031 15.1904 15.1368 15.1904 13.508H14.4904H13.7904C13.7904 14.3039 13.1055 15.0031 12.1925 15.0031V15.7031ZM14.4904 13.508H15.1904C15.1904 11.8792 13.8176 10.6129 12.1925 10.6129V11.3129V12.0129C13.1055 12.0129 13.7904 12.7121 13.7904 13.508H14.4904ZM12.1925 11.3129V10.6129C10.5673 10.6129 9.19461 11.8792 9.19461 13.508H9.89462H10.5946C10.5946 12.7121 11.2795 12.0129 12.1925 12.0129V11.3129ZM1.85206 13.8739H1.15206C1.15206 15.3006 2.35331 16.4031 3.76695 16.4031V15.7031V15.0031C3.06546 15.0031 2.55206 14.4677 2.55206 13.8739H1.85206ZM3.76695 15.7031V16.4031C5.1806 16.4031 6.38185 15.3006 6.38185 13.8739H5.68185H4.98185C4.98185 14.4677 4.46844 15.0031 3.76695 15.0031V15.7031ZM5.68185 13.8739H6.38185C6.38185 12.4471 5.1806 11.3446 3.76695 11.3446V12.0446V12.7446C4.46844 12.7446 4.98185 13.28 4.98185 13.8739H5.68185ZM3.76695 12.0446V11.3446C2.35331 11.3446 1.15206 12.4471 1.15206 13.8739H1.85206H2.55206C2.55206 13.28 3.06546 12.7446 3.76695 12.7446V12.0446ZM3.33213 5.18885L3.92142 5.56666C3.93711 5.54217 3.94472 5.53034 3.95043 5.52174C3.95482 5.51513 3.95428 5.5162 3.95157 5.51979L3.39273 5.09825L2.83389 4.67671C2.7975 4.72495 2.76696 4.77342 2.74284 4.81104L3.33213 5.18885ZM3.51151 4.97231L3.03496 4.45958C3.0052 4.48724 2.96716 4.52207 2.92685 4.5656L3.44046 5.04121L3.95407 5.51682C3.95245 5.51856 3.95172 5.51916 3.95534 5.51568C3.95768 5.51343 3.96116 5.51013 3.96679 5.50486C3.97252 5.4995 3.97913 5.49335 3.98806 5.48505L3.51151 4.97231ZM3.39273 5.09825L3.95157 5.51979C3.95074 5.52089 3.95123 5.52021 3.95274 5.5184C3.95425 5.51659 3.9549 5.51592 3.95407 5.51682L3.44046 5.04121L2.92685 4.5656C2.89492 4.60008 2.86225 4.63911 2.83389 4.67671L3.39273 5.09825Z",
                                        fill: "#121212"
                                    })
                                }),
                                " ",
                                "To be shipped within",
                                " ",
                                moment_timezone_default()((ref4 = productState.selectedPrice) === null || ref4 === void 0 ? void 0 : ref4.expected_shipping_date).format("DD MMMM YYYY")
                            ]
                        })
                    }),
                    leftInStock > 0 && // <div className={styles.truck}>
                    //   <p style={{ color: "red" }}>
                    //     <svg
                    //       width="20"
                    //       height="17"
                    //       viewBox="0 0 20 17"
                    //       fill="none"
                    //       xmlns="http://www.w3.org/2000/svg"
                    //     >
                    //       <path
                    //         d="M18.7031 3.69647H19.4031V3.69647H18.7031ZM15.6393 8.0202L15.2573 8.60675C15.4895 8.75801 15.7891 8.75801 16.0213 8.60675L15.6393 8.0202ZM12.5755 3.69647H11.8755V3.69647H12.5755ZM15.6393 0.703125V1.40312V0.703125ZM6.83078 5.42752C7.21738 5.42752 7.53078 5.11411 7.53078 4.72752C7.53078 4.34092 7.21738 4.02752 6.83078 4.02752V4.72752V5.42752ZM5.68185 12.808C5.29525 12.808 4.98185 13.1214 4.98185 13.508C4.98185 13.8946 5.29525 14.208 5.68185 14.208V13.508V12.808ZM3.90541 4.74773L4.06189 5.43002V5.43002L3.90541 4.74773ZM3.68401 4.83534L4.03765 5.43944V5.43944L3.68401 4.83534ZM0.76143 13.0563L0.119204 13.3348L0.119204 13.3348L0.76143 13.0563ZM1.85206 14.208C2.23866 14.208 2.55206 13.8946 2.55206 13.508C2.55206 13.1214 2.23866 12.808 1.85206 12.808V13.508V14.208ZM1.17596 13.4523L0.91841 14.1032H0.91841L1.17596 13.4523ZM0.724288 9.25003L0.0454 9.07941L0.0453991 9.07941L0.724288 9.25003ZM0.815996 9.03853L0.226804 8.66057L0.226804 8.66057L0.815996 9.03853ZM10.6606 3.23239C11.0472 3.23239 11.3606 2.91899 11.3606 2.53239C11.3606 2.14579 11.0472 1.83239 10.6606 1.83239V2.53239V3.23239ZM18.2542 8.86118C18.2542 8.47458 17.9408 8.16118 17.5542 8.16118C17.1676 8.16118 16.8542 8.47458 16.8542 8.86118H17.5542H18.2542ZM7.66722 2.6919L7.97358 3.3213L7.97358 3.3213L7.66722 2.6919ZM6.99775 3.33143L7.61539 3.66086V3.66086L6.99775 3.33143ZM3.33213 5.18885L2.74284 4.81104V4.81104L3.33213 5.18885ZM3.39273 5.09825L2.83389 4.67671V4.67671L3.39273 5.09825ZM3.51151 4.97231L3.98806 5.48505L3.51151 4.97231ZM3.44046 5.04121L3.95407 5.51682L3.44046 5.04121ZM18.7031 3.69647H18.0031C18.0031 4.57303 17.4082 5.48149 16.6687 6.2441C16.3143 6.60958 15.9574 6.9101 15.6882 7.11952C15.5542 7.22379 15.4433 7.30435 15.3674 7.35795C15.3294 7.38473 15.3003 7.4047 15.2814 7.41747C15.272 7.42385 15.2651 7.42843 15.261 7.43114C15.259 7.4325 15.2576 7.43339 15.257 7.43381C15.2567 7.43402 15.2565 7.43411 15.2566 7.43408C15.2566 7.43407 15.2567 7.43403 15.2568 7.43395C15.2568 7.43392 15.257 7.43384 15.257 7.43382C15.2571 7.43374 15.2573 7.43364 15.6393 8.0202C16.0213 8.60675 16.0215 8.60664 16.0217 8.60653C16.0218 8.60648 16.0219 8.60636 16.0221 8.60626C16.0224 8.60607 16.0227 8.60584 16.0231 8.60558C16.0239 8.60507 16.0249 8.60444 16.026 8.60368C16.0283 8.60216 16.0314 8.60016 16.0351 8.59767C16.0426 8.59269 16.053 8.58577 16.066 8.57697C16.092 8.55936 16.1287 8.53419 16.1745 8.50186C16.2661 8.43723 16.3946 8.3437 16.5478 8.22451C16.8531 7.98701 17.2622 7.64312 17.6737 7.21869C18.4662 6.40147 19.4031 5.14808 19.4031 3.69647H18.7031ZM15.6393 8.0202C16.0213 7.43364 16.0215 7.43374 16.0216 7.43382C16.0216 7.43384 16.0218 7.43392 16.0218 7.43395C16.0219 7.43403 16.022 7.43407 16.022 7.43408C16.022 7.43411 16.0219 7.43402 16.0216 7.43381C16.021 7.43339 16.0196 7.4325 16.0176 7.43114C16.0135 7.42843 16.0066 7.42385 15.9972 7.41747C15.9783 7.4047 15.9492 7.38473 15.9112 7.35795C15.8352 7.30435 15.7244 7.22379 15.5904 7.11952C15.3212 6.9101 14.9643 6.60958 14.6099 6.2441C13.8704 5.48149 13.2755 4.57303 13.2755 3.69647H12.5755H11.8755C11.8755 5.14808 12.8124 6.40147 13.6048 7.21869C14.0164 7.64312 14.4255 7.98701 14.7307 8.22451C14.884 8.3437 15.0125 8.43723 15.1041 8.50186C15.1499 8.53419 15.1866 8.55936 15.2126 8.57697C15.2256 8.58577 15.236 8.59269 15.2435 8.59767C15.2472 8.60016 15.2503 8.60216 15.2526 8.60368C15.2537 8.60444 15.2547 8.60507 15.2555 8.60558C15.2559 8.60584 15.2562 8.60607 15.2565 8.60626C15.2567 8.60636 15.2568 8.60648 15.2569 8.60653C15.2571 8.60664 15.2573 8.60675 15.6393 8.0202ZM12.5755 3.69647H13.2755C13.2755 3.09357 13.5205 2.51196 13.962 2.08056L13.4728 1.57986L12.9837 1.07916C12.2761 1.77047 11.8755 2.71161 11.8755 3.69647H12.5755ZM13.4728 1.57986L13.962 2.08056C14.4041 1.64861 15.0072 1.40312 15.6393 1.40312V0.703125V0.00312501C14.6463 0.00312501 13.6907 0.388381 12.9837 1.07916L13.4728 1.57986ZM15.6393 0.703125V1.40312C16.2714 1.40312 16.8744 1.64861 17.3166 2.08056L17.8057 1.57986L18.2949 1.07916C17.5879 0.388381 16.6323 0.00312501 15.6393 0.00312501V0.703125ZM17.8057 1.57986L17.3166 2.08056C17.7581 2.51196 18.0031 3.09357 18.0031 3.69647H18.7031H19.4031C19.4031 2.71161 19.0025 1.77047 18.2949 1.07916L17.8057 1.57986ZM16.1952 3.58252H15.4952C15.4952 3.49791 15.5632 3.43514 15.6398 3.43514V4.13514V4.83514C16.3299 4.83514 16.8952 4.27754 16.8952 3.58252H16.1952ZM15.6398 4.13514V3.43514C15.7165 3.43514 15.7845 3.49791 15.7845 3.58252H15.0845H14.3845C14.3845 4.27754 14.9498 4.83514 15.6398 4.83514V4.13514ZM15.0845 3.58252H15.7845C15.7845 3.66714 15.7165 3.72991 15.6398 3.72991V3.02991V2.32991C14.9498 2.32991 14.3845 2.88751 14.3845 3.58252H15.0845ZM15.6398 3.02991V3.72991C15.5632 3.72991 15.4952 3.66713 15.4952 3.58252H16.1952H16.8952C16.8952 2.88751 16.3299 2.32991 15.6398 2.32991V3.02991ZM0.703125 9.60269H0.00312501V12.4104H0.703125H1.40312V9.60269H0.703125ZM6.83078 4.72752V4.02752H4.27459V4.72752V5.42752H6.83078V4.72752ZM3.33213 5.18885L2.74284 4.81104C2.57099 5.07909 2.13534 5.75751 1.72851 6.38224C1.52488 6.69493 1.32987 6.99202 1.17923 7.21688C1.10362 7.32974 1.0413 7.42123 0.995586 7.4863C0.972469 7.51921 0.956298 7.5415 0.946255 7.55483C0.924285 7.58399 0.944917 7.55286 0.985554 7.51404L1.46908 8.0202L1.95261 8.52636C2.00777 8.47367 2.05297 8.41247 2.06447 8.3972C2.0879 8.3661 2.11411 8.32957 2.14114 8.2911C2.19571 8.21343 2.26473 8.11194 2.34233 7.99609C2.49813 7.76355 2.69709 7.46039 2.90168 7.14622C3.31129 6.51721 3.7491 5.83543 3.92142 5.56666L3.33213 5.18885ZM5.68185 13.508V14.208H6.83078V13.508V12.808H5.68185V13.508ZM4.27459 4.72752V4.02752C4.11919 4.02752 3.93232 4.02339 3.74894 4.06545L3.90541 4.74773L4.06189 5.43002C4.0504 5.43265 4.05033 5.43082 4.08335 5.42938C4.12245 5.42767 4.17509 5.42752 4.27459 5.42752V4.72752ZM3.51151 4.97231L3.98806 5.48505C4.01807 5.45716 4.03343 5.44401 4.0417 5.43737C4.04787 5.43242 4.04539 5.43491 4.03765 5.43944L3.68401 4.83534L3.33037 4.23124C3.20719 4.30335 3.11253 4.38748 3.03496 4.45958L3.51151 4.97231ZM3.90541 4.74773L3.74894 4.06545C3.60215 4.09911 3.46087 4.15484 3.33037 4.23124L3.68401 4.83534L4.03765 5.43944C4.04422 5.4356 4.05237 5.4322 4.06189 5.43002L3.90541 4.74773ZM0.703125 12.4104H0.00312501C0.00312501 12.5709 0.00270981 12.7279 0.0121918 12.8607C0.0221696 13.0004 0.0455812 13.165 0.119204 13.3348L0.76143 13.0563L1.40366 12.7778C1.41897 12.8132 1.41323 12.8253 1.40863 12.7609C1.40354 12.6896 1.40312 12.5909 1.40312 12.4104H0.703125ZM1.85206 13.508V12.808C1.66446 12.808 1.55726 12.8077 1.47849 12.8025C1.40542 12.7978 1.40747 12.7911 1.43352 12.8014L1.17596 13.4523L0.91841 14.1032C1.08522 14.1692 1.24687 14.1904 1.38744 14.1996C1.5223 14.2083 1.68277 14.208 1.85206 14.208V13.508ZM0.76143 13.0563L0.119204 13.3348C0.273416 13.6904 0.564553 13.9632 0.91841 14.1032L1.17596 13.4523L1.43352 12.8014C1.41201 12.7929 1.40492 12.7808 1.40366 12.7778L0.76143 13.0563ZM0.703125 9.60269H1.40312C1.40312 9.50683 1.40331 9.45902 1.40497 9.42429C1.40631 9.39636 1.40772 9.40256 1.40318 9.42064L0.724288 9.25003L0.0453991 9.07941C-0.00177729 9.26713 0.00312501 9.45846 0.00312501 9.60269H0.703125ZM1.46908 8.0202L0.985554 7.51404C0.885761 7.60937 0.788479 7.75435 0.735325 7.8341C0.664387 7.94054 0.586023 8.0656 0.513931 8.18313C0.441213 8.30168 0.371699 8.41778 0.318176 8.50754C0.290774 8.55349 0.268992 8.59014 0.251308 8.61974C0.230994 8.65374 0.225238 8.66301 0.226804 8.66057L0.815996 9.03853L1.40519 9.41648C1.42525 9.38521 1.47453 9.30186 1.52062 9.22457C1.57329 9.13624 1.63925 9.02611 1.70732 8.91513C1.77602 8.80313 1.84376 8.69535 1.9003 8.61053C1.92872 8.56788 1.951 8.53603 1.96691 8.51461C1.98939 8.48434 1.98177 8.49851 1.95261 8.52636L1.46908 8.0202ZM0.724288 9.25003L1.40318 9.42065C1.40327 9.42027 1.40369 9.41882 1.40519 9.41648L0.815996 9.03853L0.226804 8.66057C0.144311 8.78917 0.0828326 8.93047 0.0454 9.07941L0.724288 9.25003ZM10.6606 2.53239V1.83239H9.28185V2.53239V3.23239H10.6606V2.53239ZM6.83078 4.87386H6.13078V13.508H6.83078H7.53078V4.87386H6.83078ZM17.5542 11.6787H18.2542V8.86118H17.5542H16.8542V11.6787H17.5542ZM6.83078 13.508V14.208H9.89462V13.508V12.808H6.83078V13.508ZM17.5542 11.6787H16.8542C16.8542 11.9909 16.8121 12.1791 16.7599 12.2954C16.7154 12.3947 16.6526 12.4679 16.5359 12.5348C16.2392 12.7049 15.654 12.808 14.4904 12.808V13.508V14.208C15.6246 14.208 16.5713 14.1282 17.2321 13.7495C17.594 13.542 17.8664 13.2494 18.0373 12.8685C18.2005 12.5046 18.2542 12.0982 18.2542 11.6787H17.5542ZM9.28185 2.53239V1.83239C8.86391 1.83239 8.51023 1.8319 8.22122 1.85445C7.92493 1.87758 7.63696 1.92811 7.36087 2.06249L7.66722 2.6919L7.97358 3.3213C8.02518 3.29618 8.11555 3.26696 8.33016 3.25021C8.55205 3.23289 8.84183 3.23239 9.28185 3.23239V2.53239ZM6.83078 4.87386H7.53078C7.53078 4.45198 7.53138 4.17963 7.54911 3.97234C7.56605 3.77422 7.59479 3.69949 7.61539 3.66086L6.99775 3.33143L6.38012 3.002C6.23375 3.27641 6.179 3.5631 6.1542 3.85304C6.13019 4.13381 6.13078 4.47615 6.13078 4.87386H6.83078ZM7.66722 2.6919L7.36087 2.06249C6.94369 2.26556 6.5985 2.59256 6.38012 3.002L6.99775 3.33143L7.61539 3.66086C7.69075 3.51958 7.81427 3.39884 7.97358 3.3213L7.66722 2.6919ZM9.89462 13.508H9.19461C9.19461 15.1368 10.5673 16.4031 12.1925 16.4031V15.7031V15.0031C11.2795 15.0031 10.5946 14.3039 10.5946 13.508H9.89462ZM12.1925 15.7031V16.4031C13.8176 16.4031 15.1904 15.1368 15.1904 13.508H14.4904H13.7904C13.7904 14.3039 13.1055 15.0031 12.1925 15.0031V15.7031ZM14.4904 13.508H15.1904C15.1904 11.8792 13.8176 10.6129 12.1925 10.6129V11.3129V12.0129C13.1055 12.0129 13.7904 12.7121 13.7904 13.508H14.4904ZM12.1925 11.3129V10.6129C10.5673 10.6129 9.19461 11.8792 9.19461 13.508H9.89462H10.5946C10.5946 12.7121 11.2795 12.0129 12.1925 12.0129V11.3129ZM1.85206 13.8739H1.15206C1.15206 15.3006 2.35331 16.4031 3.76695 16.4031V15.7031V15.0031C3.06546 15.0031 2.55206 14.4677 2.55206 13.8739H1.85206ZM3.76695 15.7031V16.4031C5.1806 16.4031 6.38185 15.3006 6.38185 13.8739H5.68185H4.98185C4.98185 14.4677 4.46844 15.0031 3.76695 15.0031V15.7031ZM5.68185 13.8739H6.38185C6.38185 12.4471 5.1806 11.3446 3.76695 11.3446V12.0446V12.7446C4.46844 12.7446 4.98185 13.28 4.98185 13.8739H5.68185ZM3.76695 12.0446V11.3446C2.35331 11.3446 1.15206 12.4471 1.15206 13.8739H1.85206H2.55206C2.55206 13.28 3.06546 12.7446 3.76695 12.7446V12.0446ZM3.33213 5.18885L3.92142 5.56666C3.93711 5.54217 3.94472 5.53034 3.95043 5.52174C3.95482 5.51513 3.95428 5.5162 3.95157 5.51979L3.39273 5.09825L2.83389 4.67671C2.7975 4.72495 2.76696 4.77342 2.74284 4.81104L3.33213 5.18885ZM3.51151 4.97231L3.03496 4.45958C3.0052 4.48724 2.96716 4.52207 2.92685 4.5656L3.44046 5.04121L3.95407 5.51682C3.95245 5.51856 3.95172 5.51916 3.95534 5.51568C3.95768 5.51343 3.96116 5.51013 3.96679 5.50486C3.97252 5.4995 3.97913 5.49335 3.98806 5.48505L3.51151 4.97231ZM3.39273 5.09825L3.95157 5.51979C3.95074 5.52089 3.95123 5.52021 3.95274 5.5184C3.95425 5.51659 3.9549 5.51592 3.95407 5.51682L3.44046 5.04121L2.92685 4.5656C2.89492 4.60008 2.86225 4.63911 2.83389 4.67671L3.39273 5.09825Z"
                    //         fill="#121212"
                    //       />
                    //     </svg>{" "}
                    //     {productState.selectedPrice?.stock -
                    //       productState.selectedPrice?.block_stock >
                    //     5
                    //       ? 5
                    //       : productState.selectedPrice?.stock -
                    //         productState.selectedPrice?.block_stock}{" "}
                    //     left in stock
                    //   </p>
                    // </div>
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            })
        })
    });
};
/* harmony default export */ var delivery = (ProductDetailsDelivery);

// EXTERNAL MODULE: ./src/components/product-details/discount-detail/discount.module.scss
var discount_module = __webpack_require__(82069);
var discount_module_default = /*#__PURE__*/__webpack_require__.n(discount_module);
;// CONCATENATED MODULE: ./src/components/product-details/discount-detail/discount.tsx





var ProductDetailsDiscount = function() {
    var ref, ref1, ref2, ref3;
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    if (!productState.data || !((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.discount) === null || ref1 === void 0 ? void 0 : ref1.name)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (discount_module_default()).text_dis,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: (ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.discount) === null || ref3 === void 0 ? void 0 : ref3.name
            })
        })
    });
};
/* harmony default export */ var discount = (ProductDetailsDiscount);

// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/components/product-details/filter/filter.module.scss
var filter_module = __webpack_require__(74059);
var filter_module_default = /*#__PURE__*/__webpack_require__.n(filter_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./src/components/common/currency-inr.tsx
var currency_inr = __webpack_require__(76630);
// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
;// CONCATENATED MODULE: ./src/components/product-details/filter/filter.tsx










var getMetalIconSrc = function(purity) {
    switch(purity === null || purity === void 0 ? void 0 : purity.toLowerCase()){
        case "titanium":
            return __webpack_require__(77090);
        case "silver":
            return __webpack_require__(91332);
        case "platinum":
            return __webpack_require__(76873);
        default:
            return __webpack_require__(95409);
    }
};
var getMetalWeightIconSrc = function(purity) {
    switch(purity === null || purity === void 0 ? void 0 : purity.toLowerCase()){
        case "titanium":
            return __webpack_require__(73038);
        case "silver":
            return __webpack_require__(65664);
        case "platinum":
            return __webpack_require__(19286);
        default:
            return __webpack_require__(57042);
    }
};
var ProductDetailsFilter = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var isStock = (0,react.useMemo)(function() {
        var ref;
        return (ref = productState.data) === null || ref === void 0 ? void 0 : ref.prices.find(function(v) {
            return v.shipping_days <= parseInt("3" || 0) && v.stock > 0;
        });
    }, [
        productState
    ]);
    var showMetalWeightlist = function(array) {
        var data = array.filter(function(v) {
            var ref, ref1, ref2;
            return v.size === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.size) && v.purity === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.purity) && v.diamond_shape === ((ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.diamond_shape);
        }).filter(function(value, index, self) {
            return index === self.findIndex(function(item) {
                return item.metal_weight === value.metal_weight;
            });
        });
        var hasLess = data === null || data === void 0 ? void 0 : data.some(function(p) {
            return p.shipping_days <= parseInt("3" || 0);
        });
        var hasMore = data === null || data === void 0 ? void 0 : data.some(function(p) {
            return p.shipping_days > parseInt("3" || 0);
        });
        if (hasLess && hasMore) {
            data = data.filter(function(p) {
                return p.shipping_days <= parseInt("3" || 0);
            });
        }
        return data;
    };
    var ref29 = (0,react.useState)({
        size: (ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.size,
        purity: (ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.purity,
        diamond_shape: (ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.diamond_shape,
        metal_weight: (ref3 = productState.selectedPrice) === null || ref3 === void 0 ? void 0 : ref3.metal_weight
    }), selectedComboOptions = ref29[0], setSelectedComboOptions = ref29[1];
    var ref30 = (0,react.useState)({
        size: (ref4 = productState.selectedPrice) === null || ref4 === void 0 ? void 0 : ref4.size,
        purity: (ref5 = productState.selectedPrice) === null || ref5 === void 0 ? void 0 : ref5.purity,
        diamond_shape: (ref6 = productState.selectedPrice) === null || ref6 === void 0 ? void 0 : ref6.diamond_shape,
        metal_weight: (ref7 = productState.selectedPrice) === null || ref7 === void 0 ? void 0 : ref7.metal_weight
    }), oldComboOptions = ref30[0], setOldComboOptions = ref30[1];
    var changeCombo = function(value, type) {
        var ref;
        var newOptions = selectedComboOptions;
        var price = (ref = productState.data) === null || ref === void 0 ? void 0 : ref.prices.slice().sort(function(a, b) {
            return a.shipping_days - b.shipping_days;
        }).find(function(v) {
            return v.purity == (type == "purity" ? value : selectedComboOptions.purity) && v.size == (type == "size" ? value : selectedComboOptions.size) && v.diamond_shape == (type == "diamond_shape" ? value : selectedComboOptions.diamond_shape) && (type == "metal_weight" ? v.metal_weight == value : true);
        });
        if (!price) {
            var ref1;
            price = (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.prices.slice().sort(function(a, b) {
                return a.shipping_days - b.shipping_days;
            }).find(function(v) {
                return v[type] == value;
            });
        }
        if (price) {
            dispatch((0,slices_product/* setSelectedPrice */.BE)(price));
            setSelectedComboOptions({
                purity: price === null || price === void 0 ? void 0 : price.purity,
                size: price === null || price === void 0 ? void 0 : price.size,
                diamond_shape: price === null || price === void 0 ? void 0 : price.diamond_shape,
                metal_weight: price === null || price === void 0 ? void 0 : price.metal_weight
            });
        }
    };
    var noChange = function() {
        var ref;
        var newPrice = (ref = productState.data) === null || ref === void 0 ? void 0 : ref.prices.find(function(v) {
            return v.size == oldComboOptions.size && v.purity == oldComboOptions.purity && v.diamond_shape == oldComboOptions.diamond_shape && v.metal_weight == oldComboOptions.metal_weight;
        });
        if (newPrice) {
            dispatch((0,slices_product/* setSelectedPrice */.BE)(newPrice));
            setSelectedComboOptions(oldComboOptions);
        }
    };
    var fastDeliveryText = function(size) {
        var ref;
        var isFast = (ref = productState.data) === null || ref === void 0 ? void 0 : ref.prices.find(function(v) {
            return v.shipping_days <= parseInt("3" || 0) && v.stock > 0;
        });
        if (isFast) {
            var ref1;
            var item = (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.prices.find(function(v) {
                return v.size == size;
            });
            if (item) {
                if (item.shipping_days <= parseInt("3" || 0) && item.stock > 0) {
                    return "(Ready to Ship)";
                } else {
                    return "(Made to Order)";
                }
            }
        }
    };
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var ref31 = (0,react.useState)(false), show = ref31[0], setShow = ref31[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: "100%",
                    fontFamily: "'Poppins', sans-serif"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: "15px",
                        padding: "5px 0",
                        cursor: "pointer"
                    },
                    onClick: handleShow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                minWidth: 0,
                                gap: "15px",
                                overflowX: "auto",
                                paddingBottom: "1px"
                            },
                            children: [
                                !!productState.data.variation.size.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        paddingRight: "15px",
                                        borderRight: "1px solid #eaeaea",
                                        flexShrink: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: __webpack_require__(2166),
                                            width: 28,
                                            height: 28,
                                            alt: "Size",
                                            unoptimized: true,
                                            style: {
                                                marginRight: "10px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                marginLeft: "10px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        fontSize: "12px",
                                                        color: "#666"
                                                    },
                                                    children: "Size"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        color: "#000"
                                                    },
                                                    children: oldComboOptions === null || oldComboOptions === void 0 ? void 0 : oldComboOptions.size
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !!((ref8 = productState.data.variation.purity) === null || ref8 === void 0 ? void 0 : ref8.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        paddingRight: "15px",
                                        borderRight: "1px solid #eaeaea",
                                        flexShrink: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: getMetalIconSrc(((ref9 = productState.data) === null || ref9 === void 0 ? void 0 : ref9.type) || ""),
                                            width: 28,
                                            height: 28,
                                            alt: "Metal",
                                            unoptimized: true,
                                            style: {
                                                marginRight: "10px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                marginLeft: "5px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        fontSize: "12px",
                                                        color: "#666"
                                                    },
                                                    children: "Metal"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        color: "#000"
                                                    },
                                                    children: oldComboOptions === null || oldComboOptions === void 0 ? void 0 : oldComboOptions.purity
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !!((ref10 = productState.data.variation.diamond_shape) === null || ref10 === void 0 ? void 0 : ref10.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        paddingRight: "15px",
                                        borderRight: "1px solid #eaeaea",
                                        flexShrink: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: __webpack_require__(98256),
                                            width: 28,
                                            height: 28,
                                            alt: "Diamond",
                                            unoptimized: true,
                                            style: {
                                                marginRight: "10px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                marginLeft: "10px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        fontSize: "12px",
                                                        color: "#666"
                                                    },
                                                    children: "Diamond"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        color: "#000"
                                                    },
                                                    children: oldComboOptions === null || oldComboOptions === void 0 ? void 0 : oldComboOptions.diamond_shape
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !!((oldComboOptions === null || oldComboOptions === void 0 ? void 0 : oldComboOptions.metal_weight) || ((ref11 = productState.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.prices) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.metal_weight)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        flexShrink: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: getMetalWeightIconSrc(((ref14 = productState.data) === null || ref14 === void 0 ? void 0 : ref14.type) || ""),
                                            width: 28,
                                            height: 28,
                                            alt: "Weight",
                                            unoptimized: true,
                                            style: {
                                                marginRight: "10px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                marginLeft: "5px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        fontSize: "12px",
                                                        color: "#666"
                                                    },
                                                    children: "Metal Weight"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        fontSize: "14px",
                                                        fontWeight: "500",
                                                        color: "#000"
                                                    },
                                                    children: [
                                                        (oldComboOptions === null || oldComboOptions === void 0 ? void 0 : oldComboOptions.metal_weight) || ((ref15 = productState.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.prices) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : ref17.metal_weight),
                                                        " ",
                                                        "g"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "15px",
                                borderLeft: "1px solid #eaeaea",
                                marginLeft: "10px",
                                flexShrink: 0,
                                backgroundColor: "#fff"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "#8B0000",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    style: {
                                        marginRight: "8px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            points: "12 2 2 7 12 12 22 7 12 2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                            points: "2 12 12 17 22 12"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                            points: "2 17 12 22 22 17"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        color: "#8B0000",
                                        lineHeight: "1.2"
                                    },
                                    children: [
                                        "Check",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Variants"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                className: "right",
                onHide: function() {
                    handleClose();
                    noChange();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "main-price",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "small-text",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "large-text",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "price",
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                        value: ((ref18 = productState.selectedPrice) === null || ref18 === void 0 ? void 0 : ref18.discount) ? (ref19 = productState.selectedPrice) === null || ref19 === void 0 ? void 0 : ref19.discount.total : (ref20 = productState.selectedPrice) === null || ref20 === void 0 ? void 0 : ref20.total
                                                    })
                                                ]
                                            }),
                                            !!((ref21 = productState.selectedPrice) === null || ref21 === void 0 ? void 0 : ref21.discount) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cross-price",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                    value: productState.selectedPrice.total
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                        children: [
                            !!((ref22 = productState.data.variation.purity) === null || ref22 === void 0 ? void 0 : ref22.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (filter_module_default()).filter_heading_modal,
                                            children: "Metal Purity"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (filter_module_default()).filter_small_card_container,
                                        children: (ref23 = productState.data) === null || ref23 === void 0 ? void 0 : ref23.prices.filter(function(value, index, self) {
                                            return index === self.findIndex(function(item) {
                                                return item.purity === value.purity;
                                            });
                                        }).map(function(v, k) {
                                            var ref, ref1, ref2;
                                            var isStock = (ref = productState.data) === null || ref === void 0 ? void 0 : ref.prices.some(function(item) {
                                                return item.purity === v.purity && item.shipping_days <= parseInt("3" || 0);
                                            });
                                            var selectedMatch = v.purity === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.purity);
                                            var selectedCombination = (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.prices.slice().sort(function(a, b) {
                                                return a.shipping_days - b.shipping_days;
                                            }).find(function(x) {
                                                var ref, ref1, ref2;
                                                return x.metal_weight === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.metal_weight) && x.size === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.size) && x.diamond_shape === ((ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.diamond_shape) && x.purity === v.purity;
                                            });
                                            var shippingDays = (selectedCombination === null || selectedCombination === void 0 ? void 0 : selectedCombination.shipping_days) || 0;
                                            var fastDeliveryDays = parseInt("3" || 0);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((filter_module_default()).filter_small_card, " ").concat(selectedMatch ? (filter_module_default()).active : ""),
                                                onClick: function() {
                                                    return changeCombo(v.purity, "purity");
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (filter_module_default()).filter_small_card_heading,
                                                        children: v.purity
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (filter_module_default()).filter_small_card_body,
                                                        children: selectedMatch ? shippingDays <= fastDeliveryDays ? "in Stock!" : "made to order" : isStock ? "in Stock!" : "made to order"
                                                    })
                                                ]
                                            }, k);
                                        })
                                    })
                                ]
                            }),
                            !!productState.data.variation.size.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (filter_module_default()).filter_heading_modal,
                                                children: "Select Size"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (filter_module_default()).link_text,
                                                children: !!productState.data.size_chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: productState.data.size_chart,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        style: {
                                                            fontSize: 14,
                                                            fontWeight: 500,
                                                            color: "#FF1933"
                                                        },
                                                        children: productState.data.size_chart_label
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (filter_module_default()).filter_small_card_container,
                                        children: (ref24 = productState.data) === null || ref24 === void 0 ? void 0 : ref24.prices.filter(function(v) {
                                            var ref;
                                            return v.purity === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.purity);
                                        }).filter(function(value, index, self) {
                                            return index === self.findIndex(function(item) {
                                                return item.size === value.size;
                                            });
                                        }).map(function(v, k) {
                                            var ref, ref1, ref2;
                                            var isSelectedSize = v.size === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.size);
                                            var selectedCombination = (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.prices.slice().sort(function(a, b) {
                                                return a.shipping_days - b.shipping_days;
                                            }).find(function(x) {
                                                var ref, ref1, ref2;
                                                return x.metal_weight === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.metal_weight) && x.purity === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.purity) && x.diamond_shape === ((ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.diamond_shape) && x.size === v.size;
                                            });
                                            var fastDeliveryDays = parseInt("3" || 0);
                                            var shippingDays = (selectedCombination === null || selectedCombination === void 0 ? void 0 : selectedCombination.shipping_days) || 0;
                                            var isStock = (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.prices.some(function(item) {
                                                var ref;
                                                return item.purity === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.purity) && item.size === v.size && item.shipping_days <= fastDeliveryDays;
                                            });
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((filter_module_default()).filter_small_card_h, " ").concat(isSelectedSize ? (filter_module_default()).active : ""),
                                                onClick: function() {
                                                    return changeCombo(v.size, "size");
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (filter_module_default()).filter_small_card_heading,
                                                        children: v.size
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (filter_module_default()).filter_small_card_body,
                                                        children: isSelectedSize ? shippingDays <= fastDeliveryDays ? "in Stock!" : "made to order" : isStock ? "in Stock!" : "made to order"
                                                    })
                                                ]
                                            }, k);
                                        })
                                    })
                                ]
                            }),
                            !!((ref25 = productState.data.variation.diamond_shape) === null || ref25 === void 0 ? void 0 : ref25.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex justify-content-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (filter_module_default()).filter_heading_modal,
                                            children: "Diamond Quality"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (filter_module_default()).filter_small_card_container,
                                        children: (ref27 = (ref26 = productState.data) === null || ref26 === void 0 ? void 0 : ref26.prices.filter(function(v) {
                                            var ref, ref1;
                                            return v.size === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.size) && v.purity === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.purity);
                                        }).filter(function(value, index, self) {
                                            return index === self.findIndex(function(item) {
                                                return item.diamond_shape === value.diamond_shape;
                                            });
                                        })) === null || ref27 === void 0 ? void 0 : ref27.map(function(v, k) {
                                            var ref, ref1, ref2;
                                            var isSelectedShape = v.diamond_shape === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.diamond_shape);
                                            var selectedCombination = (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.prices.slice().sort(function(a, b) {
                                                return a.shipping_days - b.shipping_days;
                                            }).find(function(x) {
                                                var ref, ref1, ref2;
                                                return x.metal_weight === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.metal_weight) && x.size === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.size) && x.purity === ((ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.purity) && x.diamond_shape === v.diamond_shape;
                                            });
                                            var fastDeliveryDays = parseInt("3" || 0);
                                            var shippingDays = (selectedCombination === null || selectedCombination === void 0 ? void 0 : selectedCombination.shipping_days) || 0;
                                            var isStock = (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.prices.some(function(item) {
                                                var ref, ref1;
                                                return item.size === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.size) && item.purity === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.purity) && item.diamond_shape === v.diamond_shape && item.shipping_days <= fastDeliveryDays;
                                            });
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((filter_module_default()).filter_small_card, " ").concat(isSelectedShape ? (filter_module_default()).active : ""),
                                                onClick: function() {
                                                    return changeCombo(v.diamond_shape, "diamond_shape");
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (filter_module_default()).filter_small_card_heading,
                                                        children: v.diamond_shape
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (filter_module_default()).filter_small_card_body,
                                                        children: isSelectedShape ? shippingDays <= fastDeliveryDays ? "in Stock!" : "made to order" : isStock ? "in Stock!" : "made to order"
                                                    })
                                                ]
                                            }, k);
                                        })
                                    })
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex justify-content-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (filter_module_default()).filter_heading_modal,
                                    children: "Metal weight"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filter_module_default()).filter_small_card_container,
                                children: showMetalWeightlist((ref28 = productState.data) === null || ref28 === void 0 ? void 0 : ref28.prices).map(function(v, k) {
                                    var ref, ref1, ref2;
                                    var isSelectedWeight = v.metal_weight === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.metal_weight);
                                    var selectedCombination = (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.prices.slice().sort(function(a, b) {
                                        return a.shipping_days - b.shipping_days;
                                    }).find(function(x) {
                                        var ref, ref1, ref2;
                                        return x.metal_weight === v.metal_weight && x.size === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.size) && x.purity === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.purity) && x.diamond_shape === ((ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.diamond_shape);
                                    });
                                    var fastDeliveryDays = parseInt("3" || 0);
                                    var shippingDays = (selectedCombination === null || selectedCombination === void 0 ? void 0 : selectedCombination.shipping_days) || 0;
                                    var isStock = (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.prices.some(function(item) {
                                        var ref, ref1, ref2;
                                        return item.metal_weight === v.metal_weight && item.size === ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.size) && item.purity === ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.purity) && item.diamond_shape === ((ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.diamond_shape) && item.shipping_days <= fastDeliveryDays;
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((filter_module_default()).filter_small_card, " ").concat(isSelectedWeight ? (filter_module_default()).active : ""),
                                        onClick: function() {
                                            return changeCombo(v.metal_weight, "metal_weight");
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (filter_module_default()).filter_small_card_heading,
                                                children: v.metal_weight
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (filter_module_default()).filter_small_card_body,
                                                children: isSelectedWeight ? shippingDays <= fastDeliveryDays ? "in Stock!" : "made to order" : isStock ? "in Stock!" : "made to order"
                                            })
                                        ]
                                    }, k);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Footer */.Z.Footer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (filter_module_default()).button_text,
                            onClick: function() {
                                handleClose();
                                setOldComboOptions(selectedComboOptions);
                                if (window.smartech) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                                    (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Product View", {
                                        source: "web",
                                        platform: "senco",
                                        prid: (ref = productState.data) === null || ref === void 0 ? void 0 : ref.id,
                                        variant_id: (ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.id,
                                        image: (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.images[0].media,
                                        prqt: 1,
                                        product_name: (ref3 = productState.data) === null || ref3 === void 0 ? void 0 : ref3.title,
                                        amount: (ref4 = productState.data) === null || ref4 === void 0 ? void 0 : ref4.prices[0].total,
                                        product_url: "".concat(window.location.origin, "/products/").concat((ref5 = productState.data) === null || ref5 === void 0 ? void 0 : ref5.slug),
                                        discounted_price: ((ref6 = productState.selectedPrice) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.discount) === null || ref7 === void 0 ? void 0 : ref7.price) || 0,
                                        stock_availability: ((ref8 = productState.data) === null || ref8 === void 0 ? void 0 : ref8.stock) ? 1 : 0
                                    });
                                }
                            },
                            children: "CONFIRM"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var filter = (ProductDetailsFilter);

// EXTERNAL MODULE: ./src/components/product-details/fivestar/fivestar.module.scss
var fivestar_module = __webpack_require__(11456);
var fivestar_module_default = /*#__PURE__*/__webpack_require__.n(fivestar_module);
// EXTERNAL MODULE: ./src/assets/images/adv-header.png
var adv_header = __webpack_require__(2737);
// EXTERNAL MODULE: ./src/assets/images/icon-adv.jpg
var icon_adv = __webpack_require__(62511);
// EXTERNAL MODULE: ./src/assets/images/s2.png
var s2 = __webpack_require__(66202);
// EXTERNAL MODULE: ./src/assets/images/s3.png
var s3 = __webpack_require__(30516);
// EXTERNAL MODULE: ./src/assets/images/s4.png
var s4 = __webpack_require__(81806);
// EXTERNAL MODULE: ./src/assets/images/s5.png
var s5 = __webpack_require__(71380);
// EXTERNAL MODULE: ./src/assets/images/s6.png
var s6 = __webpack_require__(77787);
// EXTERNAL MODULE: ./src/assets/images/s7.png
var s7 = __webpack_require__(10906);
// EXTERNAL MODULE: ./src/assets/images/s8.png
var s8 = __webpack_require__(32223);
// EXTERNAL MODULE: ./src/assets/images/s9.png
var s9 = __webpack_require__(98047);
// EXTERNAL MODULE: ./src/assets/images/s11.png
var s11 = __webpack_require__(50205);
// EXTERNAL MODULE: ./src/assets/images/s12.png
var s12 = __webpack_require__(56742);
// EXTERNAL MODULE: ./src/assets/images/s13.png
var s13 = __webpack_require__(45624);
// EXTERNAL MODULE: ./src/assets/images/s14.png
var s14 = __webpack_require__(10631);
;// CONCATENATED MODULE: ./src/components/product-details/fivestar/fivestar.tsx
"use client";


















var ProductDetailsFivestar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-md-12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (fivestar_module_default()).advantages_main,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((fivestar_module_default()).container, " ", "container mb-4"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (fivestar_module_default()).advantages_main_header,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: adv_header/* default */.Z,
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (fivestar_module_default()).advantages_main_body,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row justify-content-center g-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: icon_adv/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Over 8 decades of legacy"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s2/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "2nd most trusted brand"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s3/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Our world-class karigari "
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (fivestar_module_default()).h4,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (fivestar_module_default()).icon_adv,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: s4/* default */.Z,
                                                                alt: ""
                                                            })
                                                        }),
                                                        "Bis hallmarked purest gold"
                                                    ]
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s5/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Right pricing"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s6/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Free lifetime maintenance"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s7/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Exchange & buyback guarantee"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s8/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Certified genuine diamonds"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s14/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Earn rewarding points"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s11/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Responsible jeweller"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s12/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Insured diamond jewellery"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s13/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Omni-Channel Service"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4 col-lg-3 col-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (fivestar_module_default()).card_adv_pad,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "d-flex justify-content-md-start",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).icon_adv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: s9/* default */.Z,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (fivestar_module_default()).h4,
                                                        children: "Rewarding Monthly Saving Scheme"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var fivestar = (ProductDetailsFivestar);

// EXTERNAL MODULE: ./src/components/product-details/price/price.module.scss
var price_module = __webpack_require__(80020);
var price_module_default = /*#__PURE__*/__webpack_require__.n(price_module);
;// CONCATENATED MODULE: ./src/components/product-details/price/price.tsx






var ProductDetailsPrice = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((price_module_default()).product_price, " product-info-sku-variant"),
            "data-sku": productState === null || productState === void 0 ? void 0 : (ref = productState.data) === null || ref === void 0 ? void 0 : ref.sku,
            "data-variant-id": productState === null || productState === void 0 ? void 0 : (ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.id,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (price_module_default()).new_price,
                    children: !!productState.selectedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.discount) ? (ref3 = productState.selectedPrice) === null || ref3 === void 0 ? void 0 : ref3.discount.total : (ref4 = productState.selectedPrice) === null || ref4 === void 0 ? void 0 : ref4.total
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (price_module_default()).price_cross,
                    children: !!((ref5 = productState.selectedPrice) === null || ref5 === void 0 ? void 0 : ref5.discount) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (price_module_default()).last_price,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                value: productState.selectedPrice.total
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var price = (ProductDetailsPrice);

// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./src/store/slices/cart.ts
var cart = __webpack_require__(45066);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./src/components/product-details/purchase/purchase.module.scss
var purchase_module = __webpack_require__(69745);
var purchase_module_default = /*#__PURE__*/__webpack_require__.n(purchase_module);
// EXTERNAL MODULE: ./src/lib/fpixel.ts
var fpixel = __webpack_require__(50634);
// EXTERNAL MODULE: ./src/lib/ppixel.ts
var ppixel = __webpack_require__(55763);
// EXTERNAL MODULE: ./src/lib/syte.ts
var syte = __webpack_require__(68320);
;// CONCATENATED MODULE: ./src/components/product-details/purchase/purchase.tsx























var ProductDetailsPurchase = function() {
    var ref;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), cartActionLoading = ref1[0], setCartActionLoading = ref1[1];
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var ref2 = (0,react.useState)({
        type: "",
        id: ""
    }), actionData = ref2[0], setActionData = ref2[1];
    var actionInProgress = (0,react.useRef)(false);
    var cartItem = (0,react.useMemo)(function() {
        return cartState.items.find(function(v) {
            var ref, ref1;
            return v.identifier == ((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "";
        }) || null;
    }, [
        cartState.items,
        (ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.id
    ]);
    var addToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var redirect, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        redirect = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                        ;
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        ;
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        setActionData({
                            type: "cart",
                            id: "".concat((productState === null || productState === void 0 ? void 0 : (ref12 = productState.selectedPrice) === null || ref12 === void 0 ? void 0 : ref12.id) || "")
                        });
                        return _ctx.abrupt("return");
                    case 7:
                        setCartActionLoading(true);
                        _ctx.prev = 8;
                        ;
                        _ctx.next = 12;
                        return http_client/* default.post */.Z.post(endpoints/* default.cart.add */.Z.cart.add(), {
                            is_solitaire: false,
                            type: "product",
                            identifier: (ref13 = productState.selectedPrice) === null || ref13 === void 0 ? void 0 : ref13.id
                        });
                    case 12:
                        if (window.Moengage) {
                            ;
                            window.Moengage.track_event("Added to Cart", {
                                name: (ref25 = productState.data) === null || ref25 === void 0 ? void 0 : ref25.title,
                                id: (ref26 = productState.data) === null || ref26 === void 0 ? void 0 : ref26.sku,
                                amount: ((ref27 = productState.selectedPrice) === null || ref27 === void 0 ? void 0 : ref27.discount) ? (ref28 = productState.selectedPrice) === null || ref28 === void 0 ? void 0 : ref28.discount.total : (ref29 = productState.selectedPrice) === null || ref29 === void 0 ? void 0 : ref29.total
                            });
                        }
                        _ctx.next = 15;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 15:
                        (0,react_toastify_esm/* toast */.Am)("Item added in cart", {
                            type: "success",
                            toastId: "cart-add-success"
                        });
                        (0,fpixel/* fbqTrackEvent */.dK)("AddToCart", {
                            content_type: "product",
                            content_ids: [
                                (ref14 = productState.data) === null || ref14 === void 0 ? void 0 : ref14.sku
                            ]
                        });
                        (0,ppixel/* ptrackEvent */.rn)("addtocart", {
                            event_id: "atc_".concat(Date.now()),
                            value: ((ref15 = productState.selectedPrice) === null || ref15 === void 0 ? void 0 : ref15.discount) ? (ref16 = productState.selectedPrice) === null || ref16 === void 0 ? void 0 : ref16.discount.total : (ref17 = productState.selectedPrice) === null || ref17 === void 0 ? void 0 : ref17.total,
                            order_quantity: 1,
                            currency: "INR"
                        });
                        if (((ref18 = productState.data) === null || ref18 === void 0 ? void 0 : ref18.categories) && ((ref19 = productState.data) === null || ref19 === void 0 ? void 0 : ref19.categories.length)) {
                            ;
                            window.dataLayer.push({
                                ecommerce: null
                            });
                            window.dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    currency: "INR",
                                    value: ((ref30 = productState.selectedPrice) === null || ref30 === void 0 ? void 0 : ref30.discount) ? (ref31 = productState.selectedPrice) === null || ref31 === void 0 ? void 0 : ref31.discount.total : (ref32 = productState.selectedPrice) === null || ref32 === void 0 ? void 0 : ref32.total,
                                    items: [
                                        {
                                            item_id: (ref33 = productState.data) === null || ref33 === void 0 ? void 0 : ref33.sku,
                                            item_name: (ref34 = productState.data) === null || ref34 === void 0 ? void 0 : ref34.title,
                                            item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                                            item_category: (0,_to_consumable_array/* default */.Z)((ref35 = productState.data) === null || ref35 === void 0 ? void 0 : ref35.categories).reverse()[0].name,
                                            item_variant: (ref36 = productState.selectedPrice) === null || ref36 === void 0 ? void 0 : ref36.purity,
                                            price: ((ref37 = productState.selectedPrice) === null || ref37 === void 0 ? void 0 : ref37.discount) ? (ref38 = productState.selectedPrice) === null || ref38 === void 0 ? void 0 : ref38.discount.total : (ref39 = productState.selectedPrice) === null || ref39 === void 0 ? void 0 : ref39.total,
                                            quantity: 1
                                        }, 
                                    ]
                                }
                            });
                        }
                        (0,syte/* syteTrackEvent */.l)({
                            name: "products_added_to_cart",
                            tag: "ecommerce",
                            osh_id: (ref20 = authState.user) === null || ref20 === void 0 ? void 0 : ref20.uuid,
                            products: [
                                {
                                    sku: (ref21 = productState.data) === null || ref21 === void 0 ? void 0 : ref21.sku,
                                    price: ((ref22 = productState.selectedPrice) === null || ref22 === void 0 ? void 0 : ref22.discount) ? (ref23 = productState.selectedPrice) === null || ref23 === void 0 ? void 0 : ref23.discount.total : (ref24 = productState.selectedPrice) === null || ref24 === void 0 ? void 0 : ref24.total,
                                    quantity: 1
                                }, 
                            ]
                        });
                        _ctx.next = 26;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t0 = _ctx["catch"](8);
                        ;
                        if (Number(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref40 = _ctx.t0.response) === null || ref40 === void 0 ? void 0 : ref40.status) === 400) {
                            (0,react_toastify_esm/* toast */.Am)("Something went wrong! Refreshing the page!", {
                                type: "error",
                                toastId: "refresh-error"
                            });
                            window.location.reload();
                        }
                    case 26:
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to cart ", {
                            source: "web",
                            platform: "senco",
                            prid: (ref = productState.data) === null || ref === void 0 ? void 0 : ref.id,
                            variant_id: (ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.id,
                            image_url: (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.images[0].media,
                            prqt: 1,
                            product_name: (ref3 = productState.data) === null || ref3 === void 0 ? void 0 : ref3.title,
                            category: ((ref4 = productState.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.categories) === null || ref5 === void 0 ? void 0 : ref5.length) ? (ref6 = (0,_to_consumable_array/* default */.Z)(productState.data.categories).reverse()[0]) === null || ref6 === void 0 ? void 0 : ref6.name : "",
                            brand: constants/* BRAND_NAME */.R,
                            amount: (ref7 = productState.selectedPrice) === null || ref7 === void 0 ? void 0 : ref7.total,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat((ref8 = productState.data) === null || ref8 === void 0 ? void 0 : ref8.slug),
                            discounted_price: ((ref9 = productState.selectedPrice) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.discount) === null || ref10 === void 0 ? void 0 : ref10.price) || 0,
                            stock_availability: ((ref11 = productState.data) === null || ref11 === void 0 ? void 0 : ref11.stock) ? 1 : 0
                        });
                        setCartActionLoading(false);
                        if (redirect) router.push("/cart");
                    case 29:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    22
                ]
            ]);
        }));
        return function addToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (confirm("Are you sure?")) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setCartActionLoading(true);
                        _ctx.next = 6;
                        return http_client/* default.delete */.Z["delete"](endpoints/* default.cart.remove */.Z.cart.remove(cartItem === null || cartItem === void 0 ? void 0 : cartItem.id));
                    case 6:
                        _ctx.next = 8;
                        return dispatch((0,cart/* fetchCartItems */.Vw)());
                    case 8:
                        if (window.Moengage) {
                            window.Moengage.track_event("Removed From Cart", {
                                name: cartItem === null || cartItem === void 0 ? void 0 : cartItem.name,
                                id: cartItem === null || cartItem === void 0 ? void 0 : cartItem.slug,
                                amount: cartItem === null || cartItem === void 0 ? void 0 : cartItem.price
                            });
                        }
                        (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Remove from cart ", {
                            source: "web",
                            platform: "senco",
                            prid: (ref = productState.data) === null || ref === void 0 ? void 0 : ref.id,
                            variant_id: (ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.id,
                            image: (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.images[0].media,
                            prqt: ((ref3 = productState.data) === null || ref3 === void 0 ? void 0 : ref3.stock) || 1,
                            product_name: (ref4 = productState.data) === null || ref4 === void 0 ? void 0 : ref4.title,
                            category: ((ref5 = productState.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.categories) === null || ref6 === void 0 ? void 0 : ref6.length) ? (ref7 = (0,_to_consumable_array/* default */.Z)(productState.data.categories).reverse()[0]) === null || ref7 === void 0 ? void 0 : ref7.name : "",
                            brand: constants/* BRAND_NAME */.R,
                            amount: (ref8 = productState.selectedPrice) === null || ref8 === void 0 ? void 0 : ref8.total,
                            product_url: "".concat(window.location.origin, "/jewellery/").concat((ref9 = productState.data) === null || ref9 === void 0 ? void 0 : ref9.slug)
                        });
                        (0,react_toastify_esm/* toast */.Am)("Item removed from cart", {
                            type: "info",
                            toastId: "cart-remove-success"
                        });
                        if (((ref10 = productState.data) === null || ref10 === void 0 ? void 0 : ref10.categories) && ((ref11 = productState.data) === null || ref11 === void 0 ? void 0 : ref11.categories.length)) {
                            ;
                            window.gtag("event", "remove_from_cart", {
                                currency: "INR",
                                value: ((ref12 = productState.selectedPrice) === null || ref12 === void 0 ? void 0 : ref12.discount) ? (ref13 = productState.selectedPrice) === null || ref13 === void 0 ? void 0 : ref13.discount.total : (ref14 = productState.selectedPrice) === null || ref14 === void 0 ? void 0 : ref14.total,
                                items: [
                                    {
                                        item_id: (ref15 = productState.data) === null || ref15 === void 0 ? void 0 : ref15.sku,
                                        item_name: (ref16 = productState.data) === null || ref16 === void 0 ? void 0 : ref16.title,
                                        item_category: (0,_to_consumable_array/* default */.Z)((ref17 = productState.data) === null || ref17 === void 0 ? void 0 : ref17.categories).reverse()[0].name,
                                        price: ((ref18 = productState.selectedPrice) === null || ref18 === void 0 ? void 0 : ref18.discount) ? (ref19 = productState.selectedPrice) === null || ref19 === void 0 ? void 0 : ref19.discount.total : (ref20 = productState.selectedPrice) === null || ref20 === void 0 ? void 0 : ref20.total,
                                        quantity: 1
                                    }, 
                                ]
                            });
                            window.dataLayer.push({
                                ecommerce: null
                            });
                            window.dataLayer.push({
                                event: "remove_from_cart",
                                ecommerce: {
                                    currency: "INR",
                                    value: ((ref21 = productState.selectedPrice) === null || ref21 === void 0 ? void 0 : ref21.discount) ? (ref22 = productState.selectedPrice) === null || ref22 === void 0 ? void 0 : ref22.discount.total : (ref23 = productState.selectedPrice) === null || ref23 === void 0 ? void 0 : ref23.total,
                                    items: [
                                        {
                                            item_id: (ref24 = productState.data) === null || ref24 === void 0 ? void 0 : ref24.sku,
                                            item_name: (ref25 = productState.data) === null || ref25 === void 0 ? void 0 : ref25.title,
                                            item_category: (0,_to_consumable_array/* default */.Z)((ref26 = productState.data) === null || ref26 === void 0 ? void 0 : ref26.categories).reverse()[0].name,
                                            price: ((ref27 = productState.selectedPrice) === null || ref27 === void 0 ? void 0 : ref27.discount) ? (ref28 = productState.selectedPrice) === null || ref28 === void 0 ? void 0 : ref28.discount.total : (ref29 = productState.selectedPrice) === null || ref29 === void 0 ? void 0 : ref29.total,
                                            quantity: 1
                                        }, 
                                    ]
                                }
                            });
                        }
                        setCartActionLoading(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var handleAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!actionInProgress.current) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            if (!(actionData.id && authState.user)) {
                                _ctx.next = 17;
                                break;
                            }
                            actionInProgress.current = true;
                            _ctx.prev = 4;
                            if (!(actionData.type === "cart")) {
                                _ctx.next = 8;
                                break;
                            }
                            _ctx.next = 8;
                            return addToCart();
                        case 8:
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](4);
                            ;
                        case 13:
                            _ctx.prev = 13;
                            setActionData({
                                type: "",
                                id: ""
                            });
                            actionInProgress.current = false;
                            return _ctx.finish(13);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        10,
                        13,
                        17
                    ]
                ]);
            }));
            return function handleAction() {
                return _ref.apply(this, arguments);
            };
        }();
        if (actionData.id && authState.user) {
            handleAction();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        authState,
        actionData
    ]);
    if (cartItem) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (purchase_module_default()).purchase_info,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    "aria-label": "Remove From Cart",
                    type: "button",
                    role: "button",
                    className: (purchase_module_default()).btn_2,
                    onClick: removeFromCart,
                    disabled: cartActionLoading,
                    children: [
                        "Remove From Cart",
                        cartActionLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                            animation: "border",
                            size: "sm",
                            className: "ms-2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/cart",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Buy Now",
                        role: "button",
                        type: "button",
                        className: (purchase_module_default()).btn_1,
                        disabled: cartActionLoading,
                        children: "Buy Now"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (purchase_module_default()).purchase_info,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Add to Cart",
                type: "button",
                role: "button",
                className: (purchase_module_default()).btn_2,
                onClick: function() {
                    return addToCart(false);
                },
                disabled: cartActionLoading,
                children: [
                    "Add to Cart",
                    cartActionLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        animation: "border",
                        size: "sm",
                        className: "ms-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Buy Now",
                type: "button",
                role: "button",
                className: (purchase_module_default()).btn_1,
                onClick: function() {
                    return addToCart(true);
                },
                disabled: cartActionLoading,
                children: "Buy Now"
            })
        ]
    });
};
/* harmony default export */ var purchase = (ProductDetailsPurchase);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/thumbs/thumbs.min.css
var thumbs_min = __webpack_require__(75083);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/product-details/similar/similar.module.scss
var similar_module = __webpack_require__(35662);
var similar_module_default = /*#__PURE__*/__webpack_require__.n(similar_module);
// EXTERNAL MODULE: ./src/components/product-card/product-card.tsx
var product_card = __webpack_require__(91740);
;// CONCATENATED MODULE: ./src/components/product-details/similar/similar.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 
















swiper_esm/* default.use */.ZP.use([
    swiper_esm/* FreeMode */.Rv,
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Thumbs */.o3
]);
var ProductDetailsSimilar = function(param) {
    var product = param.product;
    var ref;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var ref1 = (0,react.useState)([]), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react.useState)(""), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react.useState)(product === null || product === void 0 ? void 0 : (ref = product.headers) === null || ref === void 0 ? void 0 : ref["unbxd-request-id"]), requestId = ref3[0], setrequestId = ref3[1];
    (0,react.useEffect)(function() {
        // dispatch(fetchRelatedProductBySlug(router.query.slug as string));
        recommended();
    }, []);
    var recommended = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, products, payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        products = ((ref = product.data.widget1) === null || ref === void 0 ? void 0 : ref.recommendations.map(function(product) {
                            var ref, ref1, ref2, ref3;
                            return {
                                id: product === null || product === void 0 ? void 0 : product.productId,
                                title: product === null || product === void 0 ? void 0 : product.title,
                                slug: product === null || product === void 0 ? void 0 : product.productUrl.split("/")[(product === null || product === void 0 ? void 0 : product.productUrl.split("/").length) - 1],
                                sku: product === null || product === void 0 ? void 0 : product.uniqueId,
                                try_online: (product === null || product === void 0 ? void 0 : (ref = product.hasTryOnline) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "true",
                                image: product === null || product === void 0 ? void 0 : product.imageUrl[0],
                                priceId: product.variantId,
                                price: product === null || product === void 0 ? void 0 : product.price,
                                discount: {
                                    total: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    name: (product === null || product === void 0 ? void 0 : product.discountLabel) || null,
                                    price: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    text: (product === null || product === void 0 ? void 0 : product.discountLabel) || null
                                },
                                fastDelivery: (product === null || product === void 0 ? void 0 : (ref1 = product.vIsFastDelivery) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "true",
                                // deal_of_the_day: null,
                                categories: [
                                    {
                                        name: product.categoryPath1[0]
                                    }
                                ],
                                // trending: null,
                                // featured: null,
                                // recomemded: null,
                                best_seller: (product === null || product === void 0 ? void 0 : (ref2 = product.isBestSeller) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "true",
                                new_arrival: (product === null || product === void 0 ? void 0 : (ref3 = product.isNewArrival) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "true"
                            };
                        })) || [];
                        setData(products);
                        setTitle(product.data.widget1.widgetTitle);
                        if (products.length) {
                            payload = {
                                requestId: requestId,
                                pids_list: products.map(function(v) {
                                    return v.sku;
                                }),
                                experience_pagetype: "PRODUCT",
                                experience_widget: "WIDGET1"
                            };
                            (0,unbxd/* unbxdTrackEvent */.Eg)("experience_impression", payload);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function recommended() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (similar_module_default()).similar_products,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    className: "swiper-navigation-black",
                    navigation: false,
                    spaceBetween: 10,
                    slidesPerView: 2,
                    pagination: {
                        clickable: true
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 3
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 10
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 20
                        }
                    },
                    children: data === null || data === void 0 ? void 0 : data.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (similar_module_default()).jwellery,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card/* default */.Z, {
                                    product: product,
                                    unbxd: {
                                        isunbxd: true,
                                        requestId: requestId,
                                        experience_pagetype: "PRODUCT",
                                        experience_widget: "WIDGET1"
                                    }
                                })
                            })
                        }, product.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var similar = (ProductDetailsSimilar);

// EXTERNAL MODULE: ./src/components/product-details/slider/slider.tsx + 7 modules
var slider = __webpack_require__(73424);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js
var Tabs = __webpack_require__(85509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js + 1 modules
var Tab = __webpack_require__(73192);
;// CONCATENATED MODULE: ./src/assets/images/logos.png
/* harmony default export */ var logos = ({"src":"/_next/static/media/logos.e55d343d.png","height":1024,"width":1536,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAIVBMVEX6+vvs7Oz////K1un09fnb4e3X19fSytS+v72Mkb7n18MaHKobAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nBXJwQEAIAjDwLSCoPsPLD5zwbmsAOKcvHsLqoIv7p67hCVP8wANHwCAo2psyAAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/components/product-details/tab/description-tab/description-tab.tsx




var ProductDetailsDescriptionTab = function() {
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "details_text",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: productState.data.description
                }),
                productState.data.disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    style: {
                        display: "block"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Disclaimer:"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontSize: 14,
                                color: "rgb(87, 87, 87)"
                            },
                            children: productState.data.disclaimer
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var description_tab = (ProductDetailsDescriptionTab);

;// CONCATENATED MODULE: ./src/components/product-details/tab/detail-tab/tooltip.tsx


var Tooltip = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    children: [
                        " ",
                        "In case the net weight of the actual product is less than the mentioned weight, a partial refund shall be initiated."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "In case the net weight of the actual product is higher than the mentioned weight, we shall ask for the extra amount by sending a payment link."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "The final invoice amount shall be adjusted in case there is any variation in net weight."
                })
            ]
        })
    });
};
/* harmony default export */ var tooltip = (Tooltip);

// EXTERNAL MODULE: ./src/styles/tooltip.module.scss
var tooltip_module = __webpack_require__(7418);
var tooltip_module_default = /*#__PURE__*/__webpack_require__.n(tooltip_module);
;// CONCATENATED MODULE: ./src/components/product-details/tab/detail-tab/detail-tab.tsx






var ProductDetailsDetailTab = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30;
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var ref31 = (0,react.useState)(0), showToolTip = ref31[0], setshowToolTip = ref31[1];
    var divRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            //@ts-ignore
            if (divRef.current && !divRef.current.contains(event.target)) {
                setshowToolTip(0);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "details_text",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Design Code: "
                        }),
                        productState.data.sku
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Metal Purity: "
                        }),
                        (ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.purity
                    ]
                }),
                !!((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.size) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Size: "
                        }),
                        (ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.size
                    ]
                }),
                !!(((ref3 = productState.selectedPrice) === null || ref3 === void 0 ? void 0 : ref3.gold_weight) || ((ref4 = productState.selectedPrice) === null || ref4 === void 0 ? void 0 : ref4.gold2_weight)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Gold Weight: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (tooltip_module_default()).text_d_r,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    !!((ref5 = productState.selectedPrice) === null || ref5 === void 0 ? void 0 : ref5.gold_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            productState.selectedPrice.gold_weight,
                                            " g (",
                                            productState.selectedPrice.gold_purity_display_name,
                                            ")"
                                        ]
                                    }),
                                    !!((ref6 = productState.selectedPrice) === null || ref6 === void 0 ? void 0 : ref6.gold2_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            ", ",
                                            productState.selectedPrice.gold2_weight,
                                            " g (",
                                            productState.selectedPrice.gold2_purity_display_name,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (tooltip_module_default()).icon_tooltip,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((tooltip_module_default()).icon_tooltip_icon, " ").concat((tooltip_module_default()).mobile_arrow),
                                    onClick: function() {
                                        return setshowToolTip(1);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-info-circle-fill"
                                    })
                                }),
                                showToolTip === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).mobile_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).desktop_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref7 = productState.selectedPrice) === null || ref7 === void 0 ? void 0 : ref7.diamond_shape) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Diamond Quality: "
                        }),
                        (ref8 = productState.selectedPrice) === null || ref8 === void 0 ? void 0 : ref8.diamond_shape
                    ]
                }),
                !!((ref9 = productState.selectedPrice) === null || ref9 === void 0 ? void 0 : ref9.diamond_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Diamond Weight: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (tooltip_module_default()).text_d_r,
                            children: [
                                " ",
                                (ref10 = productState.selectedPrice) === null || ref10 === void 0 ? void 0 : ref10.diamond_weight,
                                " carat"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (tooltip_module_default()).icon_tooltip,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((tooltip_module_default()).icon_tooltip_icon, " ").concat((tooltip_module_default()).mobile_arrow),
                                    onClick: function() {
                                        return setshowToolTip(2);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-info-circle-fill"
                                    })
                                }),
                                showToolTip === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).mobile_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).desktop_view_tool),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref11 = productState.selectedPrice) === null || ref11 === void 0 ? void 0 : ref11.platinum_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Platinum Weight: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (tooltip_module_default()).text_d_r,
                            children: [
                                (ref12 = productState.selectedPrice) === null || ref12 === void 0 ? void 0 : ref12.platinum_weight,
                                " g"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (tooltip_module_default()).icon_tooltip,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((tooltip_module_default()).icon_tooltip_icon, " ").concat((tooltip_module_default()).mobile_arrow),
                                    onClick: function() {
                                        return setshowToolTip(3);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-info-circle-fill"
                                    })
                                }),
                                showToolTip === 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).mobile_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).desktop_view_tool),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref13 = productState.selectedPrice) === null || ref13 === void 0 ? void 0 : ref13.silver_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Silver Weight: "
                        }),
                        (ref14 = productState.selectedPrice) === null || ref14 === void 0 ? void 0 : ref14.silver_weight,
                        " g",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (tooltip_module_default()).icon_tooltip,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((tooltip_module_default()).icon_tooltip_icon, " ").concat((tooltip_module_default()).mobile_arrow),
                                    onClick: function() {
                                        return setshowToolTip(4);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-info-circle-fill"
                                    })
                                }),
                                showToolTip === 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).mobile_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).desktop_view_tool),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref15 = productState.selectedPrice) === null || ref15 === void 0 ? void 0 : ref15.titanium_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Titanium Weight: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (tooltip_module_default()).text_d_r,
                            children: [
                                (ref16 = productState.selectedPrice) === null || ref16 === void 0 ? void 0 : ref16.titanium_weight,
                                " g"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (tooltip_module_default()).icon_tooltip,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((tooltip_module_default()).icon_tooltip_icon, " ").concat((tooltip_module_default()).mobile_arrow),
                                    onClick: function() {
                                        return setshowToolTip(5);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-info-circle-fill"
                                    })
                                }),
                                showToolTip === 5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).mobile_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).desktop_view_tool),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref17 = productState.selectedPrice) === null || ref17 === void 0 ? void 0 : ref17.stone_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Stone Weight: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (tooltip_module_default()).text_d_r,
                            children: [
                                (ref18 = productState.selectedPrice) === null || ref18 === void 0 ? void 0 : ref18.stone_weight,
                                " g"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (tooltip_module_default()).icon_tooltip,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((tooltip_module_default()).icon_tooltip_icon, " ").concat((tooltip_module_default()).mobile_arrow),
                                    onClick: function() {
                                        return setshowToolTip(8);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-info-circle-fill"
                                    })
                                }),
                                showToolTip === 8 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).mobile_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).desktop_view_tool),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref19 = productState.selectedPrice) === null || ref19 === void 0 ? void 0 : ref19.polki_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Polki Weight: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (tooltip_module_default()).text_d_r,
                            children: [
                                (ref20 = productState.selectedPrice) === null || ref20 === void 0 ? void 0 : ref20.polki_weight,
                                " g"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (tooltip_module_default()).icon_tooltip,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((tooltip_module_default()).icon_tooltip_icon, " ").concat((tooltip_module_default()).mobile_arrow),
                                    onClick: function() {
                                        return setshowToolTip(6);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-info-circle-fill"
                                    })
                                }),
                                showToolTip === 6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).mobile_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).desktop_view_tool),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref21 = productState.selectedPrice) === null || ref21 === void 0 ? void 0 : ref21.kundan_weight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Kundan Weight: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (tooltip_module_default()).text_d_r,
                            children: [
                                (ref22 = productState.selectedPrice) === null || ref22 === void 0 ? void 0 : ref22.kundan_weight,
                                " g"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (tooltip_module_default()).icon_tooltip,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((tooltip_module_default()).icon_tooltip_icon, " ").concat((tooltip_module_default()).mobile_arrow),
                                    onClick: function() {
                                        return setshowToolTip(7);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-info-circle-fill"
                                    })
                                }),
                                showToolTip === 7 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).mobile_view_tool),
                                    ref: divRef,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((tooltip_module_default()).tooltip_container, " ").concat((tooltip_module_default()).desktop_view_tool),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (tooltip_module_default()).tooltip_container_main,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {})
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref23 = productState.selectedPrice) === null || ref23 === void 0 ? void 0 : ref23.no_of_diamond) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "No. of Diamond: "
                        }),
                        (ref24 = productState.selectedPrice) === null || ref24 === void 0 ? void 0 : ref24.no_of_diamond
                    ]
                }),
                !!((ref25 = productState.selectedPrice) === null || ref25 === void 0 ? void 0 : ref25.no_of_stone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "No. of Stone: "
                        }),
                        (ref26 = productState.selectedPrice) === null || ref26 === void 0 ? void 0 : ref26.no_of_stone
                    ]
                }),
                !!productState.data.pieces && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Pieces: "
                        }),
                        productState.data.pieces
                    ]
                }),
                !!((ref27 = productState.selectedPrice) === null || ref27 === void 0 ? void 0 : ref27.item_length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Item Length: "
                        }),
                        (ref28 = productState.selectedPrice) === null || ref28 === void 0 ? void 0 : ref28.item_length
                    ]
                }),
                !!((ref29 = productState.selectedPrice) === null || ref29 === void 0 ? void 0 : ref29.item_width) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Item Width: "
                        }),
                        (ref30 = productState.selectedPrice) === null || ref30 === void 0 ? void 0 : ref30.item_width
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var detail_tab = (ProductDetailsDetailTab);

;// CONCATENATED MODULE: ./src/components/product-details/tab/pricebreak-tab/pricebreak-tab.tsx





var ProductDetailsPriceBreakTab = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41;
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    if (!productState.data || !productState.selectedPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "details_text",
            children: [
                !!(((ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.gold_value) || ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.gold2_value)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Gold Value: "
                        }),
                        !!((ref2 = productState.selectedPrice) === null || ref2 === void 0 ? void 0 : ref2.gold_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: ((ref3 = productState.selectedPrice.discount) === null || ref3 === void 0 ? void 0 : ref3.gold_value) ? productState.selectedPrice.discount.gold_value : productState.selectedPrice.gold_value
                                }),
                                ((ref4 = productState.selectedPrice.discount) === null || ref4 === void 0 ? void 0 : ref4.gold_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "mx-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                value: productState.selectedPrice.gold_value
                                            })
                                        }),
                                        ((ref5 = productState.selectedPrice.discount) === null || ref5 === void 0 ? void 0 : ref5.gold_rate_discount) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "ms-2",
                                            children: [
                                                "(",
                                                (ref6 = productState.selectedPrice.discount) === null || ref6 === void 0 ? void 0 : ref6.gold_rate_discount,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                "(",
                                productState.selectedPrice.gold_purity_display_name,
                                ")"
                            ]
                        }),
                        !!((ref7 = productState.selectedPrice) === null || ref7 === void 0 ? void 0 : ref7.gold2_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                ",",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: ((ref8 = productState.selectedPrice.discount) === null || ref8 === void 0 ? void 0 : ref8.gold2_value) ? productState.selectedPrice.discount.gold2_value : productState.selectedPrice.gold2_value
                                }),
                                ((ref9 = productState.selectedPrice.discount) === null || ref9 === void 0 ? void 0 : ref9.gold2_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "mx-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                value: productState.selectedPrice.gold2_value
                                            })
                                        }),
                                        ((ref10 = productState.selectedPrice.discount) === null || ref10 === void 0 ? void 0 : ref10.gold_rate_discount) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "ms-2",
                                            children: [
                                                "(",
                                                (ref11 = productState.selectedPrice.discount) === null || ref11 === void 0 ? void 0 : ref11.gold_rate_discount,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                "(",
                                productState.selectedPrice.gold2_purity_display_name,
                                ")"
                            ]
                        })
                    ]
                }),
                !!((ref12 = productState.selectedPrice) === null || ref12 === void 0 ? void 0 : ref12.diamond_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Diamond Value: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref13 = productState.selectedPrice.discount) === null || ref13 === void 0 ? void 0 : ref13.diamond_value) ? productState.selectedPrice.discount.diamond_value : productState.selectedPrice.diamond_value
                        }),
                        ((ref14 = productState.selectedPrice.discount) === null || ref14 === void 0 ? void 0 : ref14.diamond_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("s", {
                            className: "mx-3",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: productState.selectedPrice.diamond_value
                                })
                            ]
                        })
                    ]
                }),
                !!((ref15 = productState.selectedPrice) === null || ref15 === void 0 ? void 0 : ref15.platinum_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Platinum Value: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref16 = productState.selectedPrice.discount) === null || ref16 === void 0 ? void 0 : ref16.platinum_value) ? productState.selectedPrice.discount.platinum_value : productState.selectedPrice.platinum_value
                        }),
                        ((ref17 = productState.selectedPrice.discount) === null || ref17 === void 0 ? void 0 : ref17.platinum_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "mx-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                        value: productState.selectedPrice.platinum_value
                                    })
                                }),
                                ((ref18 = productState.selectedPrice.discount) === null || ref18 === void 0 ? void 0 : ref18.platinum_rate_discount) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ms-2",
                                    children: [
                                        "(",
                                        (ref19 = productState.selectedPrice.discount) === null || ref19 === void 0 ? void 0 : ref19.platinum_rate_discount,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref20 = productState.selectedPrice) === null || ref20 === void 0 ? void 0 : ref20.silver_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Silver Value: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref21 = productState.selectedPrice.discount) === null || ref21 === void 0 ? void 0 : ref21.silver_value) ? productState.selectedPrice.discount.silver_value : productState.selectedPrice.silver_value
                        }),
                        ((ref22 = productState.selectedPrice.discount) === null || ref22 === void 0 ? void 0 : ref22.silver_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "mx-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                        value: productState.selectedPrice.silver_value
                                    })
                                }),
                                ((ref23 = productState.selectedPrice.discount) === null || ref23 === void 0 ? void 0 : ref23.silver_rate_discount) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ms-2",
                                    children: [
                                        "(",
                                        (ref24 = productState.selectedPrice.discount) === null || ref24 === void 0 ? void 0 : ref24.silver_rate_discount,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!((ref25 = productState.selectedPrice) === null || ref25 === void 0 ? void 0 : ref25.stone_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Stone Value: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref26 = productState.selectedPrice.discount) === null || ref26 === void 0 ? void 0 : ref26.stone_value) ? productState.selectedPrice.discount.stone_value : productState.selectedPrice.stone_value
                        }),
                        ((ref27 = productState.selectedPrice.discount) === null || ref27 === void 0 ? void 0 : ref27.stone_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("s", {
                            className: "mx-3",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: productState.selectedPrice.stone_value
                                })
                            ]
                        })
                    ]
                }),
                !!((ref28 = productState.selectedPrice) === null || ref28 === void 0 ? void 0 : ref28.polki_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Polki Value: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref29 = productState.selectedPrice.discount) === null || ref29 === void 0 ? void 0 : ref29.polki_value) ? productState.selectedPrice.discount.polki_value : productState.selectedPrice.polki_value
                        }),
                        ((ref30 = productState.selectedPrice.discount) === null || ref30 === void 0 ? void 0 : ref30.polki_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("s", {
                            className: "mx-3",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: productState.selectedPrice.polki_value
                                })
                            ]
                        })
                    ]
                }),
                !!((ref31 = productState.selectedPrice) === null || ref31 === void 0 ? void 0 : ref31.titanium_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Titanium Value: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref32 = productState.selectedPrice.discount) === null || ref32 === void 0 ? void 0 : ref32.titanium_value) ? productState.selectedPrice.discount.titanium_value : productState.selectedPrice.titanium_value
                        }),
                        ((ref33 = productState.selectedPrice.discount) === null || ref33 === void 0 ? void 0 : ref33.titanium_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("s", {
                            className: "mx-3",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: productState.selectedPrice.titanium_value
                                })
                            ]
                        })
                    ]
                }),
                !!((ref34 = productState.selectedPrice) === null || ref34 === void 0 ? void 0 : ref34.kundan_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Kundan Value: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref35 = productState.selectedPrice.discount) === null || ref35 === void 0 ? void 0 : ref35.kundan_value) ? productState.selectedPrice.discount.kundan_value : productState.selectedPrice.kundan_value
                        }),
                        ((ref36 = productState.selectedPrice.discount) === null || ref36 === void 0 ? void 0 : ref36.kundan_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("s", {
                            className: "mx-3",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: productState.selectedPrice.kundan_value
                                })
                            ]
                        })
                    ]
                }),
                !!((ref37 = productState.selectedPrice) === null || ref37 === void 0 ? void 0 : ref37.other_value) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                (ref38 = productState.selectedPrice) === null || ref38 === void 0 ? void 0 : ref38.other_label,
                                ": "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: productState.selectedPrice.other_value
                        })
                    ]
                }),
                !!((ref39 = productState.selectedPrice) === null || ref39 === void 0 ? void 0 : ref39.making_charge) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Making Charge: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: ((ref40 = productState.selectedPrice.discount) === null || ref40 === void 0 ? void 0 : ref40.making_charge) !== undefined ? productState.selectedPrice.discount.making_charge : productState.selectedPrice.making_charge_value
                        }),
                        ((ref41 = productState.selectedPrice.discount) === null || ref41 === void 0 ? void 0 : ref41.making_charge) !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)("s", {
                            className: "mx-3",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: productState.selectedPrice.making_charge_value
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "GST (",
                                +productState.selectedPrice.gst_percent,
                                "%): "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: productState.selectedPrice.discount ? productState.selectedPrice.discount.gst_value : productState.selectedPrice.gst_value
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Total: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                            value: productState.selectedPrice.discount ? productState.selectedPrice.discount.total : productState.selectedPrice.total
                        }),
                        productState.selectedPrice.discount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("s", {
                            className: "mx-3",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                    value: productState.selectedPrice.total
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var pricebreak_tab = (ProductDetailsPriceBreakTab);

// EXTERNAL MODULE: ./src/styles/product_detail.module.scss
var product_detail_module = __webpack_require__(1230);
var product_detail_module_default = /*#__PURE__*/__webpack_require__.n(product_detail_module);
;// CONCATENATED MODULE: ./src/components/product-details/tab/tab.tsx












var ProductDetailsTab = function() {
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (product_detail_module_default()).details_main,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                defaultActiveKey: "first",
                id: "product-details-tab",
                className: (product_detail_module_default()).nav_tabs,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        eventKey: "first",
                        title: "Description",
                        className: (product_detail_module_default()).nav_link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (product_detail_module_default()).details_text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(description_tab, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        eventKey: "second",
                        title: "Details",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (product_detail_module_default()).details_text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(detail_tab, {})
                        })
                    }),
                    productState.data.breakup_visibility == "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        eventKey: "third",
                        title: "Price Break-up",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (product_detail_module_default()).details_text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pricebreak_tab, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        eventKey: "fourth",
                        title: "Certificate Of Authenticity",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (product_detail_module_default()).details_text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (product_detail_module_default()).certificate,
                                                children: "CERTIFICATE OF AUTHENTICITY"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Every piece of jewellery that we make is certified for authenticity by third-party international laboratories like SGL, IGI, BIS and GIA."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: logos,
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var tab = (ProductDetailsTab);

// EXTERNAL MODULE: ./src/components/product-details/title/title.module.scss
var title_module = __webpack_require__(74936);
var title_module_default = /*#__PURE__*/__webpack_require__.n(title_module);
;// CONCATENATED MODULE: ./src/components/product-details/title/title.tsx





var ProductDetailsTitle = function() {
    var ref, ref1;
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var ref2;
    var stock = (ref2 = (ref = productState.selectedPrice) === null || ref === void 0 ? void 0 : ref.stock) !== null && ref2 !== void 0 ? ref2 : 0;
    var ref3;
    var blockStock = (ref3 = (ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.block_stock) !== null && ref3 !== void 0 ? ref3 : 0;
    var leftInStock = stock - blockStock;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-100",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (title_module_default()).product_title,
                    children: productState.data.title
                }),
                leftInStock > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                    className: (title_module_default()).stock_alert,
                    children: [
                        leftInStock > 5 ? 5 : leftInStock,
                        " left in stock"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (title_module_default()).product_link,
                    children: [
                        "SKU: ",
                        productState.data.sku
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var title = (ProductDetailsTitle);

// EXTERNAL MODULE: ./src/components/product-details/made-in-india-share/made-in-india-share.module.scss
var made_in_india_share_module = __webpack_require__(20244);
var made_in_india_share_module_default = /*#__PURE__*/__webpack_require__.n(made_in_india_share_module);
;// CONCATENATED MODULE: ./src/assets/images/share.svg
/* harmony default export */ var share = ({"src":"/_next/static/media/share.61f30b94.svg","height":20,"width":18});
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(92814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/index.es.js
var free_regular_svg_icons_index_es = __webpack_require__(56024);
// EXTERNAL MODULE: ./src/store/slices/wishlist.ts
var wishlist = __webpack_require__(78271);
// EXTERNAL MODULE: ./src/components/common/loading-spinner-small.tsx + 1 modules
var loading_spinner_small = __webpack_require__(66091);
;// CONCATENATED MODULE: ./src/components/product-details/made-in-india-share/made-in-india-share.tsx





















var ProductDetailsMadeInIndiaShare = function() {
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var dispatch = (0,store/* useAppDispatch */.T)();
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var actionInProgress = (0,react.useRef)(false);
    var ref = (0,react.useState)(false), wishlistActionLoading = ref[0], setwishlistActionLoading = ref[1];
    var ref1 = (0,react.useState)({
        type: "",
        id: ""
    }), actionData = ref1[0], setActionData = ref1[1];
    var wishlistItem = (0,react.useMemo)(function() {
        return wishlistState.items.find(function(v) {
            var ref;
            return v.id == ((ref = productState.data) === null || ref === void 0 ? void 0 : ref.id);
        }) || null;
    }, [
        wishlistState.items,
        productState.data
    ]);
    var addToWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!wishlistActionLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        ;
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        setActionData({
                            type: "wishlist",
                            id: "".concat((productState === null || productState === void 0 ? void 0 : (ref = productState.data) === null || ref === void 0 ? void 0 : ref.id) || "")
                        });
                        return _ctx.abrupt("return");
                    case 7:
                        setwishlistActionLoading(true);
                        _ctx.prev = 8;
                        ;
                        _ctx.next = 12;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.add */.Z.wishlist.add(), {
                            product_id: (ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.id,
                            user_id: authState.user.id
                        });
                    case 12:
                        _ctx.next = 14;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 14:
                        (0,react_toastify_esm/* toast */.Am)("Item added in wishlist", {
                            type: "success",
                            toastId: "withlist-add-success"
                        });
                        (0,fpixel/* fbqTrackEvent */.dK)("AddToWishlist", {
                            content_type: "product",
                            content_ids: [
                                (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.sku
                            ]
                        });
                        if (window.smartech) {
                            ;
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Add to wishlist ", {
                                source: "web",
                                platform: "senco",
                                prid: (ref3 = productState.data) === null || ref3 === void 0 ? void 0 : ref3.id,
                                variant_id: (ref4 = productState.selectedPrice) === null || ref4 === void 0 ? void 0 : ref4.id,
                                image: (ref5 = productState.data) === null || ref5 === void 0 ? void 0 : ref5.images[0].media,
                                prqt: ((ref6 = productState.selectedPrice) === null || ref6 === void 0 ? void 0 : ref6.stock) || 1,
                                product_name: (ref7 = productState.data) === null || ref7 === void 0 ? void 0 : ref7.title,
                                amount: (ref8 = productState.selectedPrice) === null || ref8 === void 0 ? void 0 : ref8.total,
                                product_url: "".concat(window.location.origin, "/jewellery/").concat((ref9 = productState.data) === null || ref9 === void 0 ? void 0 : ref9.slug),
                                discounted_price: ((ref10 = productState.selectedPrice) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.discount) === null || ref11 === void 0 ? void 0 : ref11.total) || 0,
                                stock_availability: ((ref12 = productState.selectedPrice) === null || ref12 === void 0 ? void 0 : ref12.stock) ? 1 : 0
                            });
                        }
                        _ctx.next = 21;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](8);
                    case 21:
                        setwishlistActionLoading(false);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    19
                ]
            ]);
        }));
        return function addToWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    var removeFromWishlist = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!wishlistActionLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (confirm("Are you sure you want to remove this product from wishlist?")) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (authState.user) {
                            _ctx.next = 7;
                            break;
                        }
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        return _ctx.abrupt("return");
                    case 7:
                        setwishlistActionLoading(true);
                        _ctx.prev = 8;
                        ;
                        _ctx.next = 12;
                        return http_client/* default.post */.Z.post(endpoints/* default.wishlist.remove */.Z.wishlist.remove(), {
                            product_id: (ref = productState.data) === null || ref === void 0 ? void 0 : ref.id,
                            user_id: authState.user.id
                        });
                    case 12:
                        _ctx.next = 14;
                        return dispatch((0,wishlist/* fetchWishlistItems */.nf)(authState.user.id));
                    case 14:
                        (0,react_toastify_esm/* toast */.Am)("Item removed from wishlist", {
                            type: "success",
                            toastId: "withlist-remove-success"
                        });
                        _ctx.next = 19;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](8);
                    case 19:
                        setwishlistActionLoading(false);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    8,
                    17
                ]
            ]);
        }));
        return function removeFromWishlist() {
            return _ref.apply(this, arguments);
        };
    }();
    var shareProduct = function() {
        var platform = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "native";
        var ref;
        var productTitle = ((ref = productState.data) === null || ref === void 0 ? void 0 : ref.title) || "Check this out!";
        var productUrl = location.href;
        var encodedUrl = encodeURIComponent(productUrl);
        var encodedText = encodeURIComponent("Look at this amazing product I found: ".concat(productTitle, " - ").concat(productUrl));
        var platformLinks = {
            whatsapp: "https://wa.me/?text=".concat(encodedText),
            email: "mailto:?subject=".concat(encodeURIComponent(productTitle), "&body=").concat(encodedText),
            linkedin: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodedUrl),
            facebook: "https://www.facebook.com/sharer/sharer.php?u=".concat(encodedUrl),
            twitter: "https://twitter.com/intent/tweet?url=".concat(encodedUrl, "&text=").concat(encodeURIComponent(productTitle)),
            copy: null
        };
        if (platform === "native" && navigator.share) {
            navigator.share({
                title: productTitle,
                text: "Look at this amazing product I found!",
                url: productUrl
            }).then(function() {
                (0,react_toastify_esm/* toast */.Am)("Product shared successfully!", {
                    type: "success",
                    toastId: "share-success"
                });
            }).catch(function(error) {
                ;
            });
            return;
        }
        if (platformLinks[platform]) {
            window.open(platformLinks[platform], "_blank");
            return;
        }
        if (platform === "copy" || !navigator.share) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(productUrl);
                (0,react_toastify_esm/* toast */.Am)("Product link copied to clipboard", {
                    type: "success",
                    toastId: "copy-link-success"
                });
            }
        }
    };
    (0,react.useEffect)(function() {
        var handleAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!actionInProgress.current) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            if (!(actionData.id && authState.user)) {
                                _ctx.next = 17;
                                break;
                            }
                            actionInProgress.current = true;
                            _ctx.prev = 4;
                            if (!(actionData.type === "wishlist")) {
                                _ctx.next = 8;
                                break;
                            }
                            _ctx.next = 8;
                            return addToWishlist();
                        case 8:
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](4);
                            ;
                        case 13:
                            _ctx.prev = 13;
                            setActionData({
                                type: "",
                                id: ""
                            });
                            actionInProgress.current = false;
                            return _ctx.finish(13);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        10,
                        13,
                        17
                    ]
                ]);
            }));
            return function handleAction() {
                return _ref.apply(this, arguments);
            };
        }();
        if (actionData.id && authState.user) {
            handleAction();
        }
    }, [
        authState,
        actionData
    ]);
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "d-flex justify-content-between align-items-center mb-1 w-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (made_in_india_share_module_default()).h4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pe-2",
                        children: "Made in India"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: __webpack_require__(99749),
                        alt: "Made in India",
                        priority: true
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "d-flex align-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "me-2",
                        children: [
                            wishlistActionLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner_small/* default */.Z, {})
                            }),
                            !wishlistActionLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: wishlistItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "pointer",
                                    onClick: removeFromWishlist,
                                    style: {
                                        color: "#000"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons_index_es/* faHeart */.m6i,
                                        width: 20,
                                        color: "rgb(143, 0, 6)",
                                        style: {
                                            position: "relative",
                                            top: -4
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "pointer",
                                    onClick: addToWishlist,
                                    style: {
                                        color: "#000"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_regular_svg_icons_index_es/* faHeart */.m6i,
                                        width: 20,
                                        color: "rgba(18, 18, 18, 1)",
                                        style: {
                                            position: "relative",
                                            top: -4
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "ms-1 pointer",
                        onClick: function() {
                            return shareProduct("native");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: share,
                            alt: "share",
                            width: 22
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var made_in_india_share = (ProductDetailsMadeInIndiaShare);

// EXTERNAL MODULE: ./src/components/product-details/rating-badge/rating-badge.module.scss
var rating_badge_module = __webpack_require__(65077);
var rating_badge_module_default = /*#__PURE__*/__webpack_require__.n(rating_badge_module);
;// CONCATENATED MODULE: ./src/components/product-details/rating-badge/rating-badge.tsx









var ProductDetailsRatingBadge = function() {
    var ref, ref1, ref2, ref3, ref4;
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var ref5 = (0,react.useState)(null), reviewSummarys = ref5[0], setReviewSummarys = ref5[1];
    (0,react.useEffect)(function() {
        var ref;
        var reviewSummary = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return http_client/* default.get */.Z.get(endpoints/* default.feedback.feedbackSummary */.Z.feedback.feedbackSummary((ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug));
                        case 4:
                            data = _ctx.sent.data;
                            setReviewSummarys(data);
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function reviewSummary() {
                return _ref.apply(this, arguments);
            };
        }();
        if ((ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug) {
            reviewSummary();
        }
    }, [
        (ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug
    ]);
    if (!productState.data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var hasRating = (reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.averageRating) || ((ref1 = productState.data) === null || ref1 === void 0 ? void 0 : ref1.avarageRating);
    var hasTotalRatings = ((ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.totalRatings) > 0 || (reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.totalRatings) > 0;
    if (!hasRating || !hasTotalRatings) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (rating_badge_module_default()).ratingBadge,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (rating_badge_module_default()).rating,
                    children: [
                        (reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.averageRating) || ((ref3 = productState.data) === null || ref3 === void 0 ? void 0 : ref3.avarageRating),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (rating_badge_module_default()).star,
                            children: "★"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (rating_badge_module_default()).divider
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (rating_badge_module_default()).totalRatings,
                    children: [
                        ((ref4 = productState.data) === null || ref4 === void 0 ? void 0 : ref4.totalRatings) || (reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.totalRatings),
                        " ",
                        "Ratings"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var rating_badge = (ProductDetailsRatingBadge);

;// CONCATENATED MODULE: ./src/assets/images/bisnew.png
/* harmony default export */ var bisnew = ({"src":"/_next/static/media/bisnew.3b490645.png","height":385,"width":478,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAPFBMVEUGRaBHcEw3Ya+nYIADR6UJRqBre68AS6miXoE9X6aqTGwASaoJRJ9iLmqiW31dY53/FBr7FR1aZKABQZ6rNewPAAAAE3RSTlOyAAJxpoNwSn2ZP569ioPPdWzJ/QuvWQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADVJREFUeJwNxEkCgCAMBMGeJOwgKv//q9ahMImQDGnCPzbH/QQinbFWnERpb867Fbp7vbz2Dxn3AT08dp5xAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/sglnew.png
/* harmony default export */ var sglnew = ({"src":"/_next/static/media/sglnew.6b07c9e5.png","height":241,"width":631,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEUXTJ8WTJ8ZTZ87Y64VS54VS56LKKnGAAAABnRSTlM6HyoMV1vmIdbYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVR4nA3CgQ0AAAjCsDH1/5clLYiagd69UAF8AggAI82FkrQAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
// EXTERNAL MODULE: ./src/store/slices/helmet.ts
var helmet = __webpack_require__(35278);
// EXTERNAL MODULE: ./src/pages/jewellery/[slug]/productDetails.module.scss
var productDetails_module = __webpack_require__(74708);
var productDetails_module_default = /*#__PURE__*/__webpack_require__.n(productDetails_module);
// EXTERNAL MODULE: ./src/components/product-details/rating/ratingProduct.module.scss
var ratingProduct_module = __webpack_require__(4493);
var ratingProduct_module_default = /*#__PURE__*/__webpack_require__.n(ratingProduct_module);
;// CONCATENATED MODULE: ./src/components/product-details/rating/ratingProduct.tsx













var RatingProduct = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var ref6 = (0,react.useState)(false), show = ref6[0], setShow = ref6[1];
    var ref7 = (0,react.useState)(null), reviewSummarys = ref7[0], setReviewSummarys = ref7[1];
    var ref8 = (0,react.useState)(null), reviewLists = ref8[0], setReviewLists = ref8[1];
    var ref9 = (0,react.useState)(null), selectedComment = ref9[0], setSelectedComment = ref9[1];
    var ref10 = (0,react.useState)(0), zoomedImg = ref10[0], setzoomedImg = ref10[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var reviewSummary = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.feedback.feedbackSummary */.Z.feedback.feedbackSummary((ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug));
                    case 3:
                        data = _ctx.sent.data;
                        setReviewSummarys(data);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function reviewSummary() {
            return _ref.apply(this, arguments);
        };
    }();
    var reviewList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(page) {
            var ref, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.feedback.feedbackSummaryList */.Z.feedback.feedbackSummaryList((ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug), {
                            params: {
                                page: page
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        setReviewLists(data);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function reviewList(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var selectedCommentData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id, ind) {
            var ref, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.feedback.reviewByCustomer */.Z.feedback.reviewByCustomer((ref = productState.data) === null || ref === void 0 ? void 0 : ref.slug, id));
                    case 3:
                        data = _ctx.sent.data;
                        setSelectedComment(data);
                        setzoomedImg(ind);
                        handleShow();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function selectedCommentData(id, ind) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        reviewSummary();
        reviewList(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productState.data
    ]);
    (0,react.useEffect)(function() {
        ;
    }, [
        reviewSummarys
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ratingProduct_module_default()).ratingproduct_main,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        reviewSummarys && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ratingProduct_module_default()).ratingproduct_main_line,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ratingProduct_module_default()).heading,
                                            children: "Happy Customer Ratings & Reviews"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-3",
                                        children: (reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.averageRating) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ratingProduct_module_default()).rating_contant,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: Number(reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.averageRating) >= 1 ? (ratingProduct_module_default()).active : "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-star-fill"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: Number(reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.averageRating) >= 2 ? (ratingProduct_module_default()).active : "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-star-fill"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: Number(reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.averageRating) >= 3 ? (ratingProduct_module_default()).active : "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-star-fill"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: Number(reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.averageRating) >= 4 ? (ratingProduct_module_default()).active : "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-star-fill"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: Number(reviewSummarys === null || reviewSummarys === void 0 ? void 0 : reviewSummarys.averageRating) == 5 ? (ratingProduct_module_default()).active : "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-star-fill"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    !!(reviewSummarys === null || reviewSummarys === void 0 ? void 0 : (ref = reviewSummarys.images) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-9",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (ratingProduct_module_default()).image_tag,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (ratingProduct_module_default()).image_heading,
                                                    children: "Images by Customers"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row g-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "slider-gift-main",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                                                slidesPerView: 5,
                                                                watchSlidesProgress: true,
                                                                navigation: {
                                                                    nextEl: ".arrow-right",
                                                                    prevEl: ".arrow-left"
                                                                },
                                                                autoHeight: true,
                                                                pagination: false,
                                                                children: [
                                                                    reviewSummarys && !!((ref1 = reviewSummarys.images) === null || ref1 === void 0 ? void 0 : ref1.length) && reviewSummarys.images.map(function(x, index) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                " ",
                                                                                x.images.map(function(v, k) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: (ratingProduct_module_default()).rating_slide_img,
                                                                                                onClick: function() {
                                                                                                    selectedCommentData(x.id, k);
                                                                                                },
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                    src: v,
                                                                                                    alt: "Rating image",
                                                                                                    height: 150,
                                                                                                    width: 140
                                                                                                })
                                                                                            }),
                                                                                            " "
                                                                                        ]
                                                                                    }, index + k);
                                                                                })
                                                                            ]
                                                                        });
                                                                    }),
                                                                    " "
                                                                ]
                                                            }),
                                                            ((ref2 = reviewSummarys.images) === null || ref2 === void 0 ? void 0 : ref2.length) > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        type: "button",
                                                                        className: "".concat((ratingProduct_module_default()).arrow_next, " ", "arrow-left"),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "16",
                                                                            height: "16",
                                                                            fill: "#999",
                                                                            viewBox: "0 0 16 16",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        type: "button",
                                                                        className: "".concat((ratingProduct_module_default()).arrow_prv, " ", "arrow-right"),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "16",
                                                                            height: "16",
                                                                            fill: "#999",
                                                                            viewBox: "0 0 16 16",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        !!(reviewLists === null || reviewLists === void 0 ? void 0 : (ref3 = reviewLists.data) === null || ref3 === void 0 ? void 0 : ref3.length) && (reviewLists === null || reviewLists === void 0 ? void 0 : reviewLists.data.map(function(v) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ratingProduct_module_default()).ratingproduct_user,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ratingProduct_module_default()).customer_review_icon,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ratingProduct_module_default()).user_icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-person-circle"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: v.user_name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                    children: v.created_at
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (v === null || v === void 0 ? void 0 : v.rating) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ratingProduct_module_default()).rating_contant,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: Number(v === null || v === void 0 ? void 0 : v.rating) >= 1 ? (ratingProduct_module_default()).active : "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "bi bi-star-fill"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: Number(v === null || v === void 0 ? void 0 : v.rating) >= 2 ? (ratingProduct_module_default()).active : "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "bi bi-star-fill"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: Number(v === null || v === void 0 ? void 0 : v.rating) >= 3 ? (ratingProduct_module_default()).active : "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "bi bi-star-fill"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: Number(v === null || v === void 0 ? void 0 : v.rating) >= 4 ? (ratingProduct_module_default()).active : "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "bi bi-star-fill"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: Number(v === null || v === void 0 ? void 0 : v.rating) == 5 ? (ratingProduct_module_default()).active : "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "bi bi-star-fill"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-3 mb-3",
                                                children: v === null || v === void 0 ? void 0 : v.comment
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ratingProduct_module_default()).user_image_container,
                                                children: v && !!((ref = v.images) === null || ref === void 0 ? void 0 : ref.length) && v.images.map(function(img) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (ratingProduct_module_default()).user_image_upload,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: (ratingProduct_module_default()).image_container,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: img,
                                                                    alt: "Rating image",
                                                                    height: 150,
                                                                    width: 140
                                                                })
                                                            })
                                                        })
                                                    });
                                                })
                                            })
                                        ]
                                    })
                                ]
                            });
                        })),
                        !!(reviewLists === null || reviewLists === void 0 ? void 0 : (ref4 = reviewLists.data) === null || ref4 === void 0 ? void 0 : ref4.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (ratingProduct_module_default()).next_button,
                                    disabled: Number(reviewLists === null || reviewLists === void 0 ? void 0 : reviewLists.totalPages) === Number(reviewLists === null || reviewLists === void 0 ? void 0 : reviewLists.page),
                                    onClick: function() {
                                        reviewList(Number(reviewLists === null || reviewLists === void 0 ? void 0 : reviewLists.page) + 1);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-chevron-right"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (ratingProduct_module_default()).prv_button,
                                    onClick: function() {
                                        reviewList(Number(reviewLists === null || reviewLists === void 0 ? void 0 : reviewLists.page) - 1);
                                    },
                                    disabled: (reviewLists === null || reviewLists === void 0 ? void 0 : reviewLists.page) == 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "bi bi-chevron-left"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                onHide: handleClose,
                animation: false,
                size: "lg",
                className: (ratingProduct_module_default()).custom_modal_user,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        className: (ratingProduct_module_default()).header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ratingProduct_module_default()).pop_image,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.images[zoomedImg],
                                            alt: "Rating image",
                                            height: 492,
                                            width: 371
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (ratingProduct_module_default()).ratingproduct_user,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ratingProduct_module_default()).customer_review_icon,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (ratingProduct_module_default()).user_icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-person-circle"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.user_name
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                    children: selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.created_at
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.rating) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (ratingProduct_module_default()).rating_contant,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: Number(selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.rating) >= 1 ? (ratingProduct_module_default()).active : "",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-star-fill"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: Number(selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.rating) >= 2 ? (ratingProduct_module_default()).active : "",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-star-fill"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: Number(selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.rating) >= 3 ? (ratingProduct_module_default()).active : "",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-star-fill"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: Number(selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.rating) >= 4 ? (ratingProduct_module_default()).active : "",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-star-fill"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: Number(selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.rating) == 5 ? (ratingProduct_module_default()).active : "",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "bi bi-star-fill"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (ratingProduct_module_default()).text,
                                                        children: [
                                                            selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.rating,
                                                            "/5"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-3 mb-3",
                                                children: selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.comment
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (ratingProduct_module_default()).user_image_container,
                                                children: selectedComment && (selectedComment === null || selectedComment === void 0 ? void 0 : (ref5 = selectedComment.images) === null || ref5 === void 0 ? void 0 : ref5.length) > 1 && (selectedComment === null || selectedComment === void 0 ? void 0 : selectedComment.images.map(function(img, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (ratingProduct_module_default()).user_image_upload,
                                                            onClick: function() {
                                                                return setzoomedImg(index);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: img,
                                                                alt: "Rating image",
                                                                height: 150,
                                                                width: 140
                                                            })
                                                        })
                                                    });
                                                }))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ratingProduct = (RatingProduct);

// EXTERNAL MODULE: ./src/components/product-details/frequentlyBrought/frequentlyBrought.module.scss
var frequentlyBrought_module = __webpack_require__(32405);
var frequentlyBrought_module_default = /*#__PURE__*/__webpack_require__.n(frequentlyBrought_module);
;// CONCATENATED MODULE: ./src/components/product-details/frequentlyBrought/frequentlyBrought.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 
















swiper_esm/* default.use */.ZP.use([
    swiper_esm/* FreeMode */.Rv,
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Thumbs */.o3
]);
var ProductFrequentlyBrought = function(param) {
    var product = param.product;
    var ref;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var ref1 = (0,react.useState)([]), data = ref1[0], setData = ref1[1];
    var ref2 = (0,react.useState)(""), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react.useState)(product === null || product === void 0 ? void 0 : (ref = product.headers) === null || ref === void 0 ? void 0 : ref["unbxd-request-id"]), requestId = ref3[0], setrequestId = ref3[1];
    (0,react.useEffect)(function() {
        // dispatch(fetchRelatedProductBySlug(router.query.slug as string));
        recommended();
    }, []);
    var recommended = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, products, payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        products = ((ref = product.data.widget3) === null || ref === void 0 ? void 0 : ref.recommendations.map(function(product) {
                            var ref, ref1, ref2, ref3;
                            return {
                                id: product === null || product === void 0 ? void 0 : product.productId,
                                title: product === null || product === void 0 ? void 0 : product.title,
                                slug: product === null || product === void 0 ? void 0 : product.productUrl.split("/")[(product === null || product === void 0 ? void 0 : product.productUrl.split("/").length) - 1],
                                sku: product === null || product === void 0 ? void 0 : product.uniqueId,
                                try_online: (product === null || product === void 0 ? void 0 : (ref = product.hasTryOnline) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "true",
                                image: product === null || product === void 0 ? void 0 : product.imageUrl[0],
                                priceId: product.variantId,
                                price: product === null || product === void 0 ? void 0 : product.price,
                                discount: {
                                    total: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    name: (product === null || product === void 0 ? void 0 : product.discountLabel) || null,
                                    price: (product === null || product === void 0 ? void 0 : product.discount) ? product === null || product === void 0 ? void 0 : product.sellingPrice : null,
                                    text: (product === null || product === void 0 ? void 0 : product.discountLabel) || null
                                },
                                fastDelivery: (product === null || product === void 0 ? void 0 : (ref1 = product.vIsFastDelivery) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === "true",
                                // deal_of_the_day: null,
                                categories: [
                                    {
                                        name: product.categoryPath1[0]
                                    }
                                ],
                                // trending: null,
                                // featured: null,
                                // recomemded: null,
                                best_seller: (product === null || product === void 0 ? void 0 : (ref2 = product.isBestSeller) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "true",
                                new_arrival: (product === null || product === void 0 ? void 0 : (ref3 = product.isNewArrival) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "true"
                            };
                        })) || [];
                        setData(products);
                        setTitle(product.data.widget3.widgetTitle);
                        if (products.length) {
                            payload = {
                                requestId: requestId,
                                pids_list: products.map(function(v) {
                                    return v.sku;
                                }),
                                experience_pagetype: "PRODUCT",
                                experience_widget: "WIDGET3"
                            };
                            (0,unbxd/* unbxdTrackEvent */.Eg)("experience_impression", payload);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function recommended() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!data.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (frequentlyBrought_module_default()).similar_products,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    className: "swiper-navigation-black",
                    navigation: false,
                    spaceBetween: 10,
                    slidesPerView: 2,
                    pagination: {
                        clickable: true
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 3
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 25
                        },
                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 25
                        }
                    },
                    children: data === null || data === void 0 ? void 0 : data.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (frequentlyBrought_module_default()).jwellery,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card/* default */.Z, {
                                    product: product,
                                    unbxd: {
                                        isunbxd: true,
                                        requestId: requestId,
                                        experience_pagetype: "PRODUCT",
                                        experience_widget: "WIDGET3"
                                    }
                                })
                            })
                        }, product.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var frequentlyBrought = (ProductFrequentlyBrought);

;// CONCATENATED MODULE: ./src/pages/jewellery/[slug]/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 








































var Product = function() {
    var ref, ref1;
    var productState = (0,es/* useSelector */.v9)(slices_product/* selectProduct */.Fn);
    var helmetState = (0,es/* useSelector */.v9)(helmet/* selectHelmet */.ZZ);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var ref2 = (0,react.useState)([]), product = ref2[0], setProduct = ref2[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            if (window.Moengage) {
                var ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
                window.Moengage.track_event("Product Viewed", {
                    name: (ref12 = productState.data) === null || ref12 === void 0 ? void 0 : ref12.title,
                    id: (ref13 = productState.data) === null || ref13 === void 0 ? void 0 : ref13.sku,
                    category: ((ref14 = productState.data) === null || ref14 === void 0 ? void 0 : ref14.categories) && ((ref15 = productState.data) === null || ref15 === void 0 ? void 0 : ref15.categories.length) ? (0,_to_consumable_array/* default */.Z)((ref16 = productState.data) === null || ref16 === void 0 ? void 0 : ref16.categories).reverse()[0].name : "",
                    sellingPrice: ((ref17 = productState.selectedPrice) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.discount) === null || ref18 === void 0 ? void 0 : ref18.price) || ((ref19 = productState.selectedPrice) === null || ref19 === void 0 ? void 0 : ref19.total),
                    stockAvailability: "yes",
                    recentlyViews: ((ref20 = authState.user) === null || ref20 === void 0 ? void 0 : ref20.name) || ""
                });
            }
            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Product View", {
                source: "web",
                platform: "senco",
                prid: (ref = productState.data) === null || ref === void 0 ? void 0 : ref.id,
                variant_id: (ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.id,
                image: (ref2 = productState.data) === null || ref2 === void 0 ? void 0 : ref2.images[0].media,
                prqt: 1,
                product_name: (ref3 = productState.data) === null || ref3 === void 0 ? void 0 : ref3.title,
                category: ((ref4 = productState.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.categories) === null || ref5 === void 0 ? void 0 : ref5.length) ? (ref6 = (0,_to_consumable_array/* default */.Z)(productState.data.categories).reverse()[0]) === null || ref6 === void 0 ? void 0 : ref6.name : "",
                brand: constants/* BRAND_NAME */.R,
                amount: (ref7 = productState.data) === null || ref7 === void 0 ? void 0 : ref7.prices[0].total,
                product_url: "".concat(window.location.origin, "/products/").concat((ref8 = productState.data) === null || ref8 === void 0 ? void 0 : ref8.slug),
                discounted_price: ((ref9 = productState.selectedPrice) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.discount) === null || ref10 === void 0 ? void 0 : ref10.price) || 0,
                stock_availability: ((ref11 = productState.data) === null || ref11 === void 0 ? void 0 : ref11.stock) ? 1 : 0
            });
        }, 500);
    }, [
        productState.data,
        productState.selectedPrice,
        authState
    ]);
    (0,react.useEffect)(function() {
        unbxdProduct();
    }, []);
    var unbxdProduct = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.unbxd */.Z.unbxd(), {
                            params: {
                                pageType: "PRODUCT",
                                uid: (0,lib.getCookie)("unbxd.userId"),
                                id: (ref = productState.data) === null || ref === void 0 ? void 0 : ref.sku
                            }
                        });
                    case 3:
                        data = _ctx.sent;
                        setProduct(data);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function unbxdProduct() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        if (!productState.data) return;
        (0,fpixel/* fbqTrackEvent */.dK)("ViewContent", {
            content_type: "product",
            content_ids: [
                (ref = productState.data) === null || ref === void 0 ? void 0 : ref.sku
            ]
        });
        if (productState.data.categories && productState.data.categories.length) {
            var ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            window.dataLayer.push({
                ecommerce: null
            });
            window.dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: "INR",
                    value: ((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.discount) === null || ref2 === void 0 ? void 0 : ref2.price) || ((ref3 = productState.selectedPrice) === null || ref3 === void 0 ? void 0 : ref3.total),
                    items: [
                        {
                            item_id: productState.data.sku,
                            item_name: productState.data.title,
                            item_brand: ga4/* GA4_ITEM_BRAND */.Ye,
                            item_category: (0,_to_consumable_array/* default */.Z)(productState.data.categories).reverse()[0].name,
                            item_variant: (ref4 = productState.selectedPrice) === null || ref4 === void 0 ? void 0 : ref4.purity,
                            price: ((ref5 = productState.selectedPrice) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.discount) === null || ref6 === void 0 ? void 0 : ref6.price) || ((ref7 = productState.selectedPrice) === null || ref7 === void 0 ? void 0 : ref7.total)
                        }, 
                    ]
                }
            });
            window.gtag("event", !!productState.data.try_online ? "page-view-with-tryon-button" : "page-view-without-tryon-button", {
                event_category: "mirrar-internal-event",
                event_label: "".concat((0,_to_consumable_array/* default */.Z)(productState.data.categories).reverse()[0].name, "/").concat(productState.data.sku)
            });
        }
        if (!authState.isUserLoading) {
            var ref8, ref9;
            (0,syte/* syteTrackEvent */.l)({
                name: "fe_page_view",
                tag: "ecommerce",
                osh_id: (ref8 = authState.user) === null || ref8 === void 0 ? void 0 : ref8.uuid,
                sku: (ref9 = productState.data) === null || ref9 === void 0 ? void 0 : ref9.sku
            });
        }
        var data = [];
        try {
            if (localStorage.getItem("recentViews")) {
                data = JSON.parse(localStorage.getItem("recentViews") || "[]");
            }
        } catch (error) {}
        if (!data.includes(productState.data.slug)) {
            data = [
                productState.data.slug
            ].concat((0,_to_consumable_array/* default */.Z)(data));
        }
        while(data.length > 10){
            data.pop();
        }
        localStorage.setItem("recentViews", JSON.stringify(data));
    }, [
        authState.isUserLoading,
        (ref = authState.user) === null || ref === void 0 ? void 0 : ref.uuid,
        productState.data,
        productState.selectedPrice, 
    ]);
    var ref3 = (0,react.useState)(false), show = ref3[0], setShow = ref3[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        return setShow(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-100",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((productDetails_module_default()).container, " ", "container"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (productDetails_module_default()).product_details_image,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (productDetails_module_default()).product_content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-12",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex flex-wrap align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(made_in_india_share, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rating_badge, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(price, {})
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (productDetails_module_default()).mrp_text,
                                                    children: "(MRP Inclusive of all taxes)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(discount, {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(title, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filter, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(delivery, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(purchase, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (productDetails_module_default()).link_all,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://play.google.com/store/search?q=bis+care+app&c=apps",
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (productDetails_module_default()).mark_h,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: bisnew,
                                                                    alt: "BIS Care App"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "https://play.google.com/store/search?q=bis+care+app&c=apps",
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (productDetails_module_default()).biscareapp,
                                                                children: "Click here to download the BIS Care App"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            !!((ref1 = productState.selectedPrice) === null || ref1 === void 0 ? void 0 : ref1.diamond_weight) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-7",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (productDetails_module_default()).link_all,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (productDetails_module_default()).sgl,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (productDetails_module_default()).sgl_image,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: sglnew,
                                                                        alt: "SGL"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (productDetails_module_default()).view,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "ps-1",
                                                                    children: [
                                                                        "Certified Diamond Jewellery To view sample certificate",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            onClick: function() {
                                                                                return setShow(true);
                                                                            },
                                                                            children: "( Click Here )"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                                                show: show,
                                                onHide: handleClose,
                                                centered: true,
                                                size: "lg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: __webpack_require__(52266),
                                                    alt: "Sample certificate",
                                                    priority: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-7 text-md-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-100",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (productDetails_module_default()).badge,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (productDetails_module_default()).icon,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                    width: "30",
                                                                    height: "30",
                                                                    viewBox: "0 0 30 30",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M29.9998 15.0001C29.9998 14.8479 29.9356 14.7027 29.8228 14.6005L27.5163 12.5094L28.8502 9.69569C28.9154 9.5579 28.9194 9.39896 28.8611 9.25819C28.8027 9.11737 28.6875 9.00778 28.5439 8.9566L25.6106 7.91133L25.7638 4.80141C25.7713 4.64932 25.7142 4.50117 25.6065 4.39346C25.4988 4.28581 25.3503 4.22924 25.1986 4.23614L22.0886 4.38931L21.0434 1.45608C20.9922 1.31245 20.8827 1.1972 20.7419 1.13884C20.6011 1.08049 20.4421 1.08442 20.3044 1.14974L17.4907 2.4836L15.3994 0.177062C15.2972 0.0642888 15.1521 0 14.9999 0C14.8477 0 14.7026 0.0642888 14.6004 0.177062L12.5091 2.4836L9.69548 1.14968C9.55779 1.08443 9.3988 1.08038 9.25798 1.13879C9.11716 1.19714 9.00757 1.3124 8.95644 1.45602L7.91123 4.38926L4.80133 4.23609C4.64859 4.22859 4.50109 4.28571 4.39344 4.39341C4.28579 4.50106 4.22862 4.64921 4.23612 4.80136L4.38923 7.91128L1.45596 8.95655C1.31234 9.00773 1.19714 9.11727 1.13873 9.25814C1.08037 9.3989 1.08431 9.5579 1.14962 9.69564L2.48359 12.5093L0.17706 14.6005C0.0642869 14.7028 0 14.8479 0 15.0001C0 15.1523 0.0642869 15.2974 0.17706 15.3996L2.48359 17.4908L1.14968 20.3045C1.08436 20.4423 1.08043 20.6012 1.13878 20.742C1.19714 20.8828 1.31239 20.9924 1.45596 21.0436L4.38918 22.0888L4.23601 25.1987C4.22852 25.3508 4.28563 25.4989 4.39333 25.6066C4.50098 25.7142 4.64854 25.771 4.80122 25.7639L7.91113 25.6108L8.95634 28.544C9.00752 28.6877 9.11706 28.8029 9.25787 28.8613C9.39864 28.9196 9.55763 28.9157 9.69537 28.8504L12.5091 27.5165L14.6003 29.823C14.7026 29.9358 14.8476 30.0001 14.9998 30.0001C15.152 30.0001 15.2972 29.9358 15.3994 29.823L17.4906 27.5165L20.3043 28.8504C20.4419 28.9157 20.6009 28.9197 20.7418 28.8613C20.8826 28.8029 20.9922 28.6877 21.0433 28.544L22.0885 25.6108L25.1984 25.764C25.3507 25.771 25.4986 25.7143 25.6063 25.6066C25.714 25.499 25.7711 25.3508 25.7636 25.1987L25.6105 22.0888L28.5438 21.0436C28.6874 20.9924 28.8026 20.8828 28.861 20.742C28.9194 20.6012 28.9154 20.4422 28.8501 20.3045L27.5161 17.4907L29.8227 15.3996C29.9356 15.2974 29.9998 15.1523 29.9998 15.0001ZM14.9999 26.0184C8.91476 26.0184 3.98167 21.0854 3.98167 15.0001C3.98167 8.9148 8.9147 3.9818 14.9999 3.9818C21.0852 3.9818 26.0182 8.91486 26.0182 15.0001C26.0182 21.0854 21.0851 26.0184 14.9999 26.0184Z",
                                                                            fill: "#8F0006"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M14.9988 26.2869C8.77465 26.2869 3.71094 21.2231 3.71094 14.9989C3.71094 8.77468 8.77465 3.71094 14.9988 3.71094C21.223 3.71094 26.2868 8.77473 26.2868 14.9989C26.2868 21.2231 21.223 26.2869 14.9988 26.2869ZM14.9988 4.25026C9.07203 4.25026 4.25026 9.07206 4.25026 14.9989C4.25026 20.9258 9.07203 25.7476 14.9988 25.7476C20.9256 25.7476 25.7474 20.9258 25.7474 14.9989C25.7474 9.07201 20.9256 4.25026 14.9988 4.25026Z",
                                                                            fill: "#ECA100"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M15.386 7.50781L17.2477 13.2372H23.2721L18.3982 16.7784L20.2598 22.5078L15.386 18.9668L10.5123 22.5078L12.3739 16.7784L7.5 13.2372H13.5244L15.386 7.50781Z",
                                                                            fill: "#D18F00"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (productDetails_module_default()).text,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "100% Certified"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (productDetails_module_default()).separator,
                                                                        children: "•"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Lifetime Exchange @store"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tab, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (productDetails_module_default()).product_certificate_mobile,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(certificate, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (productDetails_module_default()).product_certificate_desktop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((productDetails_module_default()).container, " ", "container"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(certificate, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(fivestar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((productDetails_module_default()).container, " ", "container"),
                children: !!Object.keys(product).length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(similar, {
                            product: product
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(frequentlyBrought, {
                            product: product
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(trending_design/* default */.Z, {
                            product: product,
                            pagetype: "PRODUCT"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ratingProduct, {})
        ]
    });
};
Product.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Product);


/***/ }),

/***/ 74670:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"certificate":"certificate_certificate__YK2FE","heading":"certificate_heading__n1_PF","certificate_container":"certificate_certificate_container__NiayZ","border_t_b":"certificate_border_t_b__8GHUk","icon_card":"certificate_icon_card__pDzmc"};

/***/ }),

/***/ 65065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fast_delivery":"delivery_fast_delivery__ye5n2","product_link1":"delivery_product_link1__2QvKs","check_delevery":"delivery_check_delevery__SlzLG","delivery_filed":"delivery_delivery_filed___T_mn","truck":"delivery_truck__YMCc1","container":"delivery_container__plfv_","left":"delivery_left___P3jy","icon":"delivery_icon__zwGwn","label":"delivery_label__WKXUR","toggle":"delivery_toggle__vMq3_","circle":"delivery_circle__tzo8Q","active":"delivery_active__M7xrQ"};

/***/ }),

/***/ 82069:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text_dis":"discount_text_dis__17VCD"};

/***/ }),

/***/ 74059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"size_container":"filter_size_container__sYGFb","form_select":"filter_form_select__Ucmfi","product_filter_details":"filter_product_filter_details__VgB7l","product_filter_container":"filter_product_filter_container__10xkP","filter_text_size":"filter_filter_text_size__QmHAq","filter_button_container":"filter_filter_button_container__mvF5j","small_text":"filter_small_text__BKa55","large_text":"filter_large_text__Wttmy","button":"filter_button__kcBul","filter_heading_modal":"filter_filter_heading_modal__7LoyT","link_text":"filter_link_text__q3ZN3","filter_small_card_container":"filter_filter_small_card_container__LYtY_","filter_small_card":"filter_filter_small_card__T8fHI","filter_small_card_heading":"filter_filter_small_card_heading__GRS_D","filter_small_card_body":"filter_filter_small_card_body__OftfC","filter_small_card_h":"filter_filter_small_card_h__SVYAf","active":"filter_active__JPG_O","button_text":"filter_button_text__TdAnq"};

/***/ }),

/***/ 11456:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sencofiveyear":"fivestar_sencofiveyear__Fgyq5","bgimage":"fivestar_bgimage__QdxwO","sencofiveyear_main":"fivestar_sencofiveyear_main__aMqGw","icon_box":"fivestar_icon_box__Q9GBy","first":"fivestar_first__aIJmA","h4":"fivestar_h4__yJOw1","number":"fivestar_number___S0d3","text1":"fivestar_text1__4vU6a","icon_box_m":"fivestar_icon_box_m__I6DA9","advantages_main":"fivestar_advantages_main__JzUUw","advantages_main_body":"fivestar_advantages_main_body__lTXRA","card_adv_pad":"fivestar_card_adv_pad__3VDPx","icon_adv":"fivestar_icon_adv__80pex","advantages_main_header":"fivestar_advantages_main_header__tZ9DA","skv":"fivestar_skv__f2MpW","h3":"fivestar_h3__GhZqK","container":"fivestar_container__G_W9L"};

/***/ }),

/***/ 32405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"similar_products":"frequentlyBrought_similar_products__VjagO","jwellery":"frequentlyBrought_jwellery__1z8x8","price":"frequentlyBrought_price__bQjW4","price_main":"frequentlyBrought_price_main__Gfj93","price_discount":"frequentlyBrought_price_discount__ZHgAA","heart":"frequentlyBrought_heart__HNGQl"};

/***/ }),

/***/ 20244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h4":"made-in-india-share_h4__B5Lyw"};

/***/ }),

/***/ 80020:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_price":"price_product_price__enQX5","price_cross":"price_price_cross__4bVpd","new_price":"price_new_price__7iRYM","last_price":"price_last_price__4Akbn","save_rupess":"price_save_rupess__xVhd2"};

/***/ }),

/***/ 69745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"purchase_info":"purchase_purchase_info__iUtIu","btn_1":"purchase_btn_1__wlZpo","btn_2":"purchase_btn_2__THhci"};

/***/ }),

/***/ 65077:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ratingBadge":"rating-badge_ratingBadge__z_Ml8","rating":"rating-badge_rating__G5d7_","star":"rating-badge_star__uwUMY","divider":"rating-badge_divider__knLBw","totalRatings":"rating-badge_totalRatings__NPOQ3"};

/***/ }),

/***/ 4493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ratingproduct_main":"ratingProduct_ratingproduct_main__9MwRi","heading":"ratingProduct_heading__Mm3mc","ratingproduct_main_line":"ratingProduct_ratingproduct_main_line__YgL8a","verified":"ratingProduct_verified__AQcah","based_text":"ratingProduct_based_text__lqgI1","rating_contant":"ratingProduct_rating_contant__tcml8","active":"ratingProduct_active__BOeN2","text":"ratingProduct_text__zAvAa","rating_tag":"ratingProduct_rating_tag__G_OuH","rating_heading":"ratingProduct_rating_heading__6wl3K","rating_tag_button":"ratingProduct_rating_tag_button__KF54f","image_tag":"ratingProduct_image_tag__w1avs","image_heading":"ratingProduct_image_heading__cCf3y","image_container":"ratingProduct_image_container__LCoXS","ratingproduct_user":"ratingProduct_ratingproduct_user__8s1lk","customer_review_head":"ratingProduct_customer_review_head__xQgy5","star_rate":"ratingProduct_star_rate__HoJk8","text_green":"ratingProduct_text_green__FBWo6","customer_review_icon":"ratingProduct_customer_review_icon__nelBw","user_icon":"ratingProduct_user_icon__qEfeo","user_image_container":"ratingProduct_user_image_container__CFRQM","user_image_upload":"ratingProduct_user_image_upload__ndVQS","custom_modal_user":"ratingProduct_custom_modal_user__i1g2X","header":"ratingProduct_header__NdUuC","pop_image":"ratingProduct_pop_image__fI0Az","next_button":"ratingProduct_next_button__yrsa9","prv_button":"ratingProduct_prv_button__za33U","rating_slide_img":"ratingProduct_rating_slide_img__N625B","ratings":"ratingProduct_ratings__Pb3cc","rating_color":"ratingProduct_rating_color__GLV1X","review_count":"ratingProduct_review_count__GZVnO","arrow_next":"ratingProduct_arrow_next__Q7IzV","arrow_prv":"ratingProduct_arrow_prv__LdqzJ"};

/***/ }),

/***/ 35662:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"similar_products":"similar_similar_products__CAqNJ","jwellery":"similar_jwellery__Ss4Oz","price":"similar_price__hkjjM","price_main":"similar_price_main__ggAu2","price_discount":"similar_price_discount__1ITY8","heart":"similar_heart__zFpMt"};

/***/ }),

/***/ 74936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_title":"title_product_title__YbFQ1","stock_alert":"title_stock_alert__QaLF9","product_link":"title_product_link__iEX__","product_link1":"title_product_link1__qTfME","h4":"title_h4__l4UHl","sgl":"title_sgl__l7JDZ","view":"title_view__94dTM","ratingBadge":"title_ratingBadge__7_FNB","rating":"title_rating__3J0SM","star":"title_star__mQLr2","divider":"title_divider__jDuw7","totalRatings":"title_totalRatings__oh8_s"};

/***/ }),

/***/ 74708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product_details_image":"productDetails_product_details_image__RFAZc","product_content":"productDetails_product_content__r6Vj4","book_appointment":"productDetails_book_appointment__5C9Ii","product_certificate_mobile":"productDetails_product_certificate_mobile__F6jzB","link_all":"productDetails_link_all__SgKZg","mark_h":"productDetails_mark_h__noQpe","biscareapp":"productDetails_biscareapp__0Kf5E","sgl":"productDetails_sgl__DqlhU","sgl_image":"productDetails_sgl_image__miITt","view":"productDetails_view__Ar9JA","mrp_text":"productDetails_mrp_text__o9iZx","badge":"productDetails_badge__b05sw","icon":"productDetails_icon__aZ2Ob","text":"productDetails_text__qgm62","separator":"productDetails_separator__rGrQr","product_certificate_desktop":"productDetails_product_certificate_desktop__3MxSg","container":"productDetails_container__RnVRT"};

/***/ }),

/***/ 1230:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"details_main":"product_detail_details_main__BFUew","active":"product_detail_active__G5zSG","nav_item":"product_detail_nav_item__FNSV7","show":"product_detail_show__WDUYE","details_text":"product_detail_details_text__K__v0"};

/***/ }),

/***/ 7418:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltip_container":"tooltip_tooltip_container__Z5_57","icon_tooltip":"tooltip_icon_tooltip__88CDU","icon_tooltip_icon":"tooltip_icon_tooltip_icon__4_lkZ","tooltip_container_main":"tooltip_tooltip_container_main__daPAg","text_d_r":"tooltip_text_d_r__vfBbx","mobile_view_tool":"tooltip_mobile_view_tool__nhxEr","desktop_view_tool":"tooltip_desktop_view_tool__ZjSEF","mobile_arrow":"tooltip_mobile_arrow__3FTQr"};

/***/ }),

/***/ 14434:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trending_design":"trending_design_trending_design__htpF_","trending_design_header":"trending_design_trending_design_header__ThAO1","h2":"trending_design_h2__36N4s","trending_design_main":"trending_design_trending_design_main__HchNh","trending_design_card":"trending_design_trending_design_card__F8JQi","trending_design_wishlist":"trending_design_trending_design_wishlist___SqtY","add_to_card":"trending_design_add_to_card___6b4g","btn_get_started":"trending_design_btn_get_started__yuemW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,1726,6646,1251,7604,9774,2888,179], function() { return __webpack_exec__(88429); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);